"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_TRANSLATION_KEY_PATTERNS = exports.ROUTE_COMBINED_UI_NAVIGATION_KEY_SET = exports.SystemTranslationKeys = exports.SYSTEM_TRANSLATION_DEFAULTS = exports.PROPERTY_LEVEL_PRE_APPLICATION_KEYS = exports.PROPERTY_LEVEL_SCREENING_KEYS = exports.PROPERTY_TRANSLATABLE_KEY_PREFIXES = exports.DEFAULT_SYSTEM_TRANSLATIONS = exports.SystemTranslatableItems = exports.SystemTranslatableItem = exports.SystemTranslationScope = exports.SystemTranslationCategory = exports.SystemTranslation = void 0;
exports.getSystemTranslatableItems = getSystemTranslatableItems;
exports.getPropertySystemTranslatableItems = getPropertySystemTranslatableItems;
exports.getDefaultSystemTranslationsMap = getDefaultSystemTranslationsMap;
/**
 * Represents a system translation record for an application.
 * System translations include shell UI (login, signup), navigation buttons,
 * notifications, and other application-level text that doesn't change per form version.
 */
var SystemTranslation = /** @class */ (function () {
    function SystemTranslation() {
        this.localeCode = '';
        this.localeName = '';
        this.isDefault = false;
        this.updatedAt = new Date();
        this.translations = {};
    }
    return SystemTranslation;
}());
exports.SystemTranslation = SystemTranslation;
/**
 * Categories of system translatable items
 */
var SystemTranslationCategory;
(function (SystemTranslationCategory) {
    SystemTranslationCategory["Navigation"] = "navigation";
    SystemTranslationCategory["Login"] = "login";
    SystemTranslationCategory["Signup"] = "signup";
    SystemTranslationCategory["Validation"] = "validation";
    SystemTranslationCategory["Notifications"] = "notifications";
    SystemTranslationCategory["Common"] = "common";
})(SystemTranslationCategory || (exports.SystemTranslationCategory = SystemTranslationCategory = {}));
var SystemTranslationScope;
(function (SystemTranslationScope) {
    SystemTranslationScope["Application"] = "application";
    SystemTranslationScope["Property"] = "property";
})(SystemTranslationScope || (exports.SystemTranslationScope = SystemTranslationScope = {}));
/**
 * Represents a single system translatable item
 */
var SystemTranslatableItem = /** @class */ (function () {
    function SystemTranslatableItem() {
        this.key = '';
        this.category = SystemTranslationCategory.Common;
        this.defaultValue = '';
        this.label = '';
        this.scope = SystemTranslationScope.Application;
    }
    return SystemTranslatableItem;
}());
exports.SystemTranslatableItem = SystemTranslatableItem;
/**
 * Response containing all system translatable items grouped by category
 */
var SystemTranslatableItems = /** @class */ (function () {
    function SystemTranslatableItems() {
        this.navigation = [];
        this.login = [];
        this.signup = [];
        this.validation = [];
        this.notifications = [];
        this.common = [];
    }
    return SystemTranslatableItems;
}());
exports.SystemTranslatableItems = SystemTranslatableItems;
/**
 * Default system translations - these serve as the base English translations
 * and are used to populate the translatable items list.
 */
exports.DEFAULT_SYSTEM_TRANSLATIONS = [
    // Navigation
    {
        key: 'nav.next',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Next',
        label: 'Next Button',
    },
    {
        key: 'nav.back',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Back',
        label: 'Back Button',
    },
    {
        key: 'nav.previous',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Previous',
        label: 'Previous Button',
    },
    {
        key: 'nav.submit',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Submit',
        label: 'Submit Button',
    },
    {
        key: 'nav.saveAndClose',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Save & Close',
        label: 'Save & Close Button',
    },
    {
        key: 'nav.continue',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Continue',
        label: 'Continue Button',
    },
    {
        key: 'nav.steps',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Steps',
        label: 'Step Navigation Label',
    },
    {
        key: 'nav.application',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Application',
        label: 'Application Title',
    },
    {
        key: 'nav.applicationSteps',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Application Steps',
        label: 'Application Steps Title',
    },
    {
        key: 'nav.stepOf',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Step {{current}} of {{total}}',
        label: 'Step Progress Text',
        params: ['current', 'total'],
    },
    {
        key: 'nav.incompleteFields',
        category: SystemTranslationCategory.Navigation,
        defaultValue: '{{count}} Incomplete fields',
        label: 'Incomplete Fields Error',
        params: ['count'],
    },
    // Login
    {
        key: 'shell.login.heading',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Applicant Center - Log In',
        label: 'Page Heading',
    },
    {
        key: 'shell.login.emailLabel',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Email',
        label: 'Email Field Label',
    },
    {
        key: 'shell.login.passwordLabel',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Password',
        label: 'Password Field Label',
    },
    {
        key: 'shell.login.submitButton',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Login',
        label: 'Login Button',
    },
    {
        key: 'shell.login.createAccountLink',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Create Account',
        label: 'Create Account Link',
    },
    {
        key: 'shell.login.forgotPasswordLink',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Forgot Password?',
        label: 'Forgot Password Link',
    },
    {
        key: 'shell.login.sessionExpired',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Your session has expired',
        label: 'Session Expired Message',
    },
    {
        key: 'shell.login.failedHeading',
        category: SystemTranslationCategory.Login,
        defaultValue: "We couldn't sign you in.",
        label: 'Login Failed Heading',
    },
    {
        key: 'shell.login.failedMessage',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Check your email and password and try again, <resetPassword>reset your password</resetPassword>, or <createAccount>create an account</createAccount>.',
        label: 'Login Failed Message',
    },
    {
        key: 'shell.login.alreadyHaveAccount',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Already have an account?',
        label: 'Already Have Account Text',
    },
    // Passwordless Login
    {
        key: 'shell.passwordless.instructions',
        category: SystemTranslationCategory.Login,
        defaultValue: "Enter your email address and we'll send you a six-digit code to sign in.",
        label: 'Passwordless Login Instructions',
    },
    {
        key: 'shell.passwordless.getCode',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Get Code',
        label: 'Get Code Button',
    },
    {
        key: 'shell.passwordless.requestFailed',
        category: SystemTranslationCategory.Login,
        defaultValue: 'We could not send a code. Please try again.',
        label: 'Request Code Failure Message',
    },
    {
        key: 'shell.passwordless.checkEmail',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Check your email',
        label: 'Verification Modal Heading',
    },
    {
        key: 'shell.passwordless.codeSent',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Check your email for a six-digit code.',
        label: 'Verification Code Instructions Message',
    },
    {
        key: 'shell.passwordless.loginCodeInstructions',
        category: SystemTranslationCategory.Login,
        defaultValue: 'If an account exists for {{email}}, a code will be sent to this email address. Enter it below to continue.',
        label: 'Passwordless Login Verification Instructions',
        params: ['email'],
    },
    {
        key: 'shell.passwordless.verificationCodeLabel',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Enter verification code',
        label: 'Verification Code Field Label',
    },
    {
        key: 'shell.passwordless.verificationCodeDigit',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Verification code digit {{index}}',
        label: 'Verification Code Digit Accessibility Label',
        params: ['index'],
    },
    {
        key: 'shell.passwordless.verify',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Verify',
        label: 'Verify Code Button',
    },
    {
        key: 'shell.passwordless.verifyFailed',
        category: SystemTranslationCategory.Login,
        defaultValue: 'That code could not be verified. Please try again.',
        label: 'Verification Failure Message',
    },
    {
        key: 'shell.passwordless.verificationExpired',
        category: SystemTranslationCategory.Login,
        defaultValue: 'This code has expired. Request a new code to continue.',
        label: 'Expired Verification Code Message',
    },
    {
        key: 'shell.passwordless.verificationLocked',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Verification is temporarily locked. Please try again after some time.',
        label: 'Locked Verification Code Message',
    },
    {
        key: 'shell.passwordless.verificationRateLimited',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Too many attempts. Request a new code to continue.',
        label: 'Rate Limited Verification Message',
    },
    {
        key: 'shell.passwordless.signupFailed',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Failed to create Application',
        label: 'Passwordless Signup Failure Message',
    },
    {
        key: 'shell.passwordless.sessionFailed',
        category: SystemTranslationCategory.Login,
        defaultValue: 'We could not complete sign in. Request a new code to continue.',
        label: 'Passwordless Session Failure Message',
    },
    {
        key: 'shell.passwordless.resendCountdown',
        category: SystemTranslationCategory.Login,
        defaultValue: "Didn't get a code? You can resend it in {{seconds}}s",
        label: 'Resend Code Countdown',
        params: ['seconds'],
    },
    {
        key: 'shell.passwordless.resend',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Resend code',
        label: 'Resend Code Button',
    },
    {
        key: 'shell.passwordless.resendFailed',
        category: SystemTranslationCategory.Login,
        defaultValue: 'We could not resend a code. Please try again.',
        label: 'Resend Code Failure Message',
    },
    // Passwordless Signup
    {
        key: 'shell.passwordlessSignup.instructions',
        category: SystemTranslationCategory.Signup,
        defaultValue: "Enter your details and we'll send a six-digit code to verify your email.",
        label: 'Passwordless Signup Instructions',
    },
    // Password Invitations
    {
        key: 'shell.signup.invitationOpenApplication',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Open application',
        label: 'Invitation Application Retry Button',
    },
    {
        key: 'shell.signup.invitationPasswordPolicy',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Use 8–50 characters with uppercase and lowercase letters, a number, and a special character: # ? ! @ $ % ^ & * -',
        label: 'Invitation Password Policy',
    },
    {
        key: 'shell.signup.invitationOpeningApplication',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Opening your application...',
        label: 'Invitation Application Opening Message',
    },
    {
        key: 'shell.signup.invitationRedirectingToLogin',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Redirecting you to login...',
        label: 'Invitation Login Redirect Message',
    },
    {
        key: 'shell.signup.invitationUnavailable',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'This invitation cannot be continued. Request a new invitation.',
        label: 'Invitation Unavailable Message',
    },
    {
        key: 'shell.signup.invitationAlreadyUsed',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'This invitation was already used. Sign in with your email and password to continue.',
        label: 'Invitation Already Used Message',
    },
    {
        key: 'shell.signup.invitationCompletionPending',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Your password was saved. Retry opening the application without resetting it again.',
        label: 'Invitation Completion Pending Message',
    },
    {
        key: 'shell.signup.invitationOpenFailed',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Unable to open your application. Please try again.',
        label: 'Invitation Application Failure Message',
    },
    {
        key: 'shell.signup.invitationInvalidPhoneNumber',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'The phone number from your guest card is invalid. Please correct it in Personal Information before continuing.',
        label: 'Invitation Invalid Phone Number Warning',
    },
    // Forgot Password
    {
        key: 'shell.forgotPassword.heading',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Forgot your password?',
        label: 'Forgot Password Heading',
    },
    {
        key: 'shell.forgotPassword.instructions',
        category: SystemTranslationCategory.Login,
        defaultValue: "Enter your email address below. We'll send you a link to reset your password.",
        label: 'Forgot Password Instructions',
    },
    {
        key: 'shell.forgotPassword.backToLogin',
        category: SystemTranslationCategory.Login,
        defaultValue: 'Back to Login',
        label: 'Back to Login Link',
    },
    {
        key: 'shell.forgotPassword.successMessage',
        category: SystemTranslationCategory.Login,
        defaultValue: 'If the email exists, a password reset email has been sent. Please check your email for further instructions.',
        label: 'Password Reset Success Message',
    },
    // Signup / Create Account
    {
        key: 'shell.signup.heading',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Applicant Center - Create Account',
        label: 'Page Heading',
    },
    {
        key: 'shell.signup.firstNameLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'First Name',
        label: 'First Name Field Label',
    },
    {
        key: 'shell.signup.lastNameLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Last Name',
        label: 'Last Name Field Label',
    },
    {
        key: 'shell.signup.emailLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Email',
        label: 'Email Field Label',
    },
    {
        key: 'shell.signup.birthDateLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Birth Date',
        label: 'Birth Date Field Label',
    },
    {
        key: 'shell.signup.phoneNumberLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Phone Number',
        label: 'Phone Number Field Label',
    },
    {
        key: 'shell.signup.passwordLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Password',
        label: 'Password Field Label',
    },
    {
        key: 'shell.signup.confirmPasswordLabel',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Confirm Password',
        label: 'Confirm Password Field Label',
    },
    {
        key: 'shell.signup.submitButton',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Create Account',
        label: 'Create Account Button',
    },
    {
        key: 'shell.signup.loginLink',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Login',
        label: 'Login Link',
    },
    {
        key: 'shell.signup.marketingEmailOptIn',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Please tick if you would like to receive information about our services and any special offers',
        label: 'Marketing Email Opt-In Consent',
        scope: SystemTranslationScope.Property,
    },
    {
        key: 'shell.signup.passwordShow',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Show',
        label: 'Show Password Button',
    },
    {
        key: 'shell.signup.passwordHide',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Hide',
        label: 'Hide Password Button',
    },
    {
        key: 'shell.signup.passwordMustInclude',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Your password must include:',
        label: 'Password Requirements Heading',
    },
    {
        key: 'shell.signup.passwordCriteriaLength',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'At least 8 characters',
        label: 'Password Criteria: Length',
    },
    {
        key: 'shell.signup.passwordCriteriaNumber',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'A number',
        label: 'Password Criteria: Number',
    },
    {
        key: 'shell.signup.passwordCriteriaLowercase',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'A lowercase letter',
        label: 'Password Criteria: Lowercase',
    },
    {
        key: 'shell.signup.passwordCriteriaUppercase',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'An uppercase letter',
        label: 'Password Criteria: Uppercase',
    },
    {
        key: 'shell.signup.passwordCriteriaSpecialChar',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'A special character',
        label: 'Password Criteria: Special Character',
    },
    {
        key: 'shell.signup.creatingAccount',
        category: SystemTranslationCategory.Signup,
        defaultValue: 'Creating account',
        label: 'Creating Account Loading Text',
    },
    // Validation Messages
    {
        key: 'validation.required',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'This field is required',
        label: 'Required Field Error',
    },
    {
        key: 'validation.fieldRequired',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{label}} is required',
        label: 'Field Required Error (with label)',
        params: ['label'],
    },
    {
        key: 'validation.invalidEmail',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Enter a valid email address',
        label: 'Invalid Email Error',
    },
    {
        key: 'validation.novaEligibilityCompassRequiredField',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'This field is required to begin NOVA Eligibility Compass.',
        label: 'NOVA Eligibility Compass Required Field Note',
    },
    {
        key: 'validation.novaEligibilityCompassEmployerNameRequired',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Employer name of Income/Assets is required to begin NOVA Eligibility Compass.',
        label: 'NOVA Eligibility Compass Employer Name Required Note',
    },
    // Verification field messages
    {
        key: 'verification.status.pendingTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pending',
        label: 'Verification Pending Title',
    },
    {
        key: 'verification.status.pendingDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verification is Pending',
        label: 'Verification Pending Description',
    },
    {
        key: 'verification.status.notStartedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Not Started',
        label: 'Verification Not Started Title',
    },
    {
        key: 'verification.status.notStartedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verification has not been started',
        label: 'Verification Not Started Description',
    },
    {
        key: 'verification.status.inProgressTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'In Progress',
        label: 'Verification In Progress Title',
    },
    {
        key: 'verification.status.inProgressDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your verification is underway. Please note that this process may take up to 30 minutes to complete',
        label: 'Verification In Progress Description',
    },
    {
        key: 'verification.status.reinitiatedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Reinitiation',
        label: 'Verification Reinitiation Title',
    },
    {
        key: 'verification.status.reinitiatedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your verification process has been reinitiated.',
        label: 'Verification Reinitiation Description',
    },
    {
        key: 'verification.status.successTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Success',
        label: 'Verification Success Title',
    },
    {
        key: 'verification.checkStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check Status',
        label: 'Check Verification Status Button',
    },
    {
        key: 'verification.error.required',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This field is required.',
        label: 'Verification Required Error',
    },
    {
        key: 'verification.error.inProgress',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please wait verification is in progress.',
        label: 'Verification In Progress Error',
    },
    {
        key: 'verification.error.failed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verification Failed, Please contact property manager.',
        label: 'Verification Failed Error',
    },
    {
        key: 'verification.identity.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'ID Verification',
        label: 'ID Verification Title',
    },
    {
        key: 'verification.identity.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Securely upload a valid government-issued ID to confirm your identity.',
        label: 'ID Verification Description',
    },
    {
        key: 'verification.identity.action',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Begin ID Verification',
        label: 'Begin ID Verification Button',
    },
    {
        key: 'verification.identity.successDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'ID Verification complete',
        label: 'ID Verification Success Description',
    },
    {
        key: 'verification.identity.failedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Invalid Documents',
        label: 'ID Verification Failed Title',
    },
    {
        key: 'verification.identity.failedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The documents provided were unable to be verified.',
        label: 'ID Verification Failed Description',
    },
    {
        key: 'verification.income.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income Verification',
        label: 'Income Verification Title',
    },
    {
        key: 'verification.income.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Securely connect your bank account for fast income verification.',
        label: 'Income Verification Description',
    },
    {
        key: 'verification.income.action',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Link Bank Account',
        label: 'Link Bank Account Button',
    },
    {
        key: 'verification.income.successDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income Verification completed',
        label: 'Income Verification Success Description',
    },
    {
        key: 'verification.income.failedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to Verify Income',
        label: 'Income Verification Failed Title',
    },
    {
        key: 'verification.income.failedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: "We couldn't verify your income. To continue, please try verifying through your payroll provider.",
        label: 'Income Verification Failed Description',
    },
    {
        key: 'verification.payroll.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payroll Verification',
        label: 'Payroll Verification Title',
    },
    {
        key: 'verification.payroll.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Connect your payroll provider to verify your income.',
        label: 'Payroll Verification Description',
    },
    {
        key: 'verification.payroll.action',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Connect Payroll',
        label: 'Connect Payroll Button',
    },
    {
        key: 'verification.payroll.successDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payroll Verification completed',
        label: 'Payroll Verification Success Description',
    },
    {
        key: 'verification.payroll.failedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to Verify Payroll',
        label: 'Payroll Verification Failed Title',
    },
    {
        key: 'verification.payroll.failedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: "We couldn't verify your payroll information. Please contact support for assistance.",
        label: 'Payroll Verification Failed Description',
    },
    {
        key: 'verification.document.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Document Verification',
        label: 'Document Verification Title',
    },
    {
        key: 'verification.document.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload and verify your documents for identity confirmation.',
        label: 'Document Verification Description',
    },
    {
        key: 'verification.document.action',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload Documents',
        label: 'Upload Documents Button',
    },
    {
        key: 'verification.document.inProgressDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your documents are being reviewed. Please note that this process may take up to 30 minutes to complete',
        label: 'Document Verification In Progress Description',
    },
    {
        key: 'verification.document.successDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Document Verification completed',
        label: 'Document Verification Success Description',
    },
    {
        key: 'verification.document.failedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to Verify Documents',
        label: 'Document Verification Failed Title',
    },
    {
        key: 'verification.document.failedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: "We couldn't verify your documents. Please ensure they are clear and valid.",
        label: 'Document Verification Failed Description',
    },
    {
        key: 'verification.novaEligibilityCompass.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NOVA Eligibility Compass',
        label: 'NOVA Eligibility Compass Title',
    },
    {
        key: 'verification.novaEligibilityCompass.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Securely verify your household eligibility for affordable housing programs.',
        label: 'NOVA Eligibility Compass Description',
    },
    {
        key: 'verification.novaEligibilityCompass.beginEligibilityCheck',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Begin Eligibility Check',
        label: 'NOVA Eligibility Compass Begin Button',
    },
    {
        key: 'verification.novaEligibilityCompass.loading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Starting eligibility check…',
        label: 'NOVA Eligibility Compass Loading Label',
    },
    {
        key: 'verification.novaEligibilityCompass.successTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Success',
        label: 'NOVA Eligibility Compass Success Title',
    },
    {
        key: 'verification.novaEligibilityCompass.successDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income verification has been completed',
        label: 'NOVA Eligibility Compass Success Description',
    },
    {
        key: 'verification.novaEligibilityCompass.failedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We were unable to verify your Income',
        label: 'NOVA Eligibility Compass Failed Title',
    },
    {
        key: 'verification.novaEligibilityCompass.failedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'A member of our community staff will contact you to verify your Income manually.',
        label: 'NOVA Eligibility Compass Failed Description',
    },
    {
        key: 'verification.novaEligibilityCompass.inProgressTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income verification in progress',
        label: 'NOVA Eligibility Compass In Progress Title',
    },
    {
        key: 'verification.novaEligibilityCompass.inProgressDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your Income verification is currently in progress.',
        label: 'NOVA Eligibility Compass In Progress Description',
    },
    {
        key: 'verification.novaEligibilityCompass.notStarted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NOVA Eligibility Verification Not Started Yet.',
        label: 'NOVA Eligibility Compass Not Started Status',
    },
    {
        key: 'verification.novaEligibilityCompass.modalStartedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Eligibility Check Started',
        label: 'NOVA Eligibility Compass Started Modal Title',
    },
    {
        key: 'verification.novaEligibilityCompass.modalFailedTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Eligibility Check Failed',
        label: 'NOVA Eligibility Compass Failed Modal Title',
    },
    {
        key: 'verification.novaEligibilityCompass.close',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Close',
        label: 'NOVA Eligibility Compass Close Button',
    },
    {
        key: 'verification.novaEligibilityCompass.startedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Thanks — we have everything we need. Your eligibility results will be reviewed with your application.',
        label: 'NOVA Eligibility Compass Started Message',
    },
    {
        key: 'verification.novaEligibilityCompass.genericErrorMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We could not complete your eligibility check right now. Please try again in a moment.',
        label: 'NOVA Eligibility Compass Generic Error Message',
    },
    {
        key: 'verification.novaEligibilityCompass.inProgressMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NOVA eligibility check is in progress.',
        label: 'NOVA Eligibility Compass In Progress Message',
    },
    {
        key: 'verification.novaEligibilityCompass.exitedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Applicant exited the NOVA eligibility check.',
        label: 'NOVA Eligibility Compass Exited Message',
    },
    {
        key: 'verification.novaEligibilityCompass.errorMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NOVA eligibility check could not be completed.',
        label: 'NOVA Eligibility Compass Error Message',
    },
    {
        key: 'verification.novaEligibilityCompass.errorCodeMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NOVA eligibility check failed: {{errorType}}.',
        label: 'NOVA Eligibility Compass Error Code Message',
        params: ['errorType'],
    },
    {
        key: 'verification.novaEligibilityCompass.invalidTokenMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your eligibility check session expired. Please start the check again.',
        label: 'NOVA Eligibility Compass Invalid Token Message',
    },
    {
        key: 'verification.novaEligibilityCompass.timeoutMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The eligibility check timed out. Please try again.',
        label: 'NOVA Eligibility Compass Timeout Message',
    },
    {
        key: 'verification.novaEligibilityCompass.supplierErrorMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'One of our verification partners is unavailable right now. Please try again in a few minutes.',
        label: 'NOVA Eligibility Compass Supplier Error Message',
    },
    {
        key: 'validation.maxLength',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{label}} must be less than {{max}} characters',
        label: 'Max Length Error',
        params: ['label', 'max'],
    },
    {
        key: 'validation.minLength',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{label}} must be at least {{min}} characters',
        label: 'Min Length Error',
        params: ['label', 'min'],
    },
    {
        key: 'validation.min',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{label}} must be at least {{min}}',
        label: 'Min Value Error',
        params: ['label', 'min'],
    },
    {
        key: 'validation.minimumCoApplicant',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'At least one co-applicant required',
        label: 'Minimum Co-Applicant Error',
    },
    {
        key: 'validation.minimumGuarantor',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'At least one guarantor required',
        label: 'Minimum Guarantor Error',
    },
    {
        key: 'validation.minimumGuarantors',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'At least {{count}} guarantors required',
        label: 'Minimum Guarantors Error',
        params: ['count'],
    },
    {
        key: 'validation.minimumAlternateId',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Select at least one Alternate ID.',
        label: 'Minimum Alternate ID Error',
    },
    {
        key: 'validation.minimumAlternateIds',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Select at least {{count}} Alternate IDs.',
        label: 'Minimum Alternate IDs Error',
        params: ['count'],
    },
    {
        key: 'validation.invalidPhone',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Invalid phone number format',
        label: 'Invalid Phone Error',
    },
    {
        key: 'validation.invalidSsn',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Enter a valid 9-digit Social Security number.',
        label: 'Invalid Social Security Number Error',
    },
    {
        key: 'validation.invalidNationalInsuranceNumber',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Enter a National Insurance number that is 2 letters, 6 numbers, then A, B, C or D.',
        label: 'Invalid National Insurance Number Error',
    },
    {
        key: 'common.showNationalInsuranceNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Show National Insurance number',
        label: 'Show National Insurance Number',
    },
    {
        key: 'common.hideNationalInsuranceNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Hide National Insurance number',
        label: 'Hide National Insurance Number',
    },
    {
        key: 'validation.invalidPostalCode',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Invalid postal code format.',
        label: 'Invalid Postal Code Error',
    },
    {
        key: 'validation.invalidManagerEmail',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Invalid manager email address',
        label: 'Invalid Manager Email Error',
    },
    {
        key: 'validation.dateFieldMissing',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{label}} is missing',
        label: 'Date Field Missing Error',
        params: ['label'],
    },
    {
        key: 'validation.dateStartAfterEnd',
        category: SystemTranslationCategory.Validation,
        defaultValue: '{{startLabel}} is greater than {{endLabel}}',
        label: 'Date Range Error',
        params: ['startLabel', 'endLabel'],
    },
    {
        key: 'validation.email',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Please enter a valid email address.',
        label: 'Invalid Email Error',
    },
    {
        key: 'validation.invalidName',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Please enter a valid name.',
        label: 'Invalid Name Error',
    },
    {
        key: 'validation.passwordRequired',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Password is required',
        label: 'Password Required Error',
    },
    {
        key: 'validation.confirmPasswordRequired',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Confirm Password is required',
        label: 'Confirm Password Required Error',
    },
    {
        key: 'validation.passwordsDoNotMatch',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Passwords do not match',
        label: 'Passwords Mismatch Error',
    },
    {
        key: 'validation.passwordMinLength',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Password must be at least 8 characters long',
        label: 'Password Min Length Error',
    },
    {
        key: 'validation.passwordRequirements',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Password must have a minimum of 8 characters, including at least one uppercase letter, one lowercase letter, one number, and one special character',
        label: 'Password Requirements Error',
    },
    {
        key: 'validation.passwordMaxLength',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Password must be 50 characters or fewer',
        label: 'Password Max Length Error',
    },
    {
        key: 'validation.moneygramAccountRequired',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Please create a MoneyGram account.',
        label: 'MoneyGram Account Required Error',
    },
    {
        key: 'validation.applicationStepUnavailable',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'The current application step is unavailable. Please reload.',
        label: 'Application Step Unavailable Error',
    },
    {
        key: 'validation.applicationStepsIncomplete',
        category: SystemTranslationCategory.Validation,
        defaultValue: 'Complete or correct these steps before submitting your application: {{steps}}.',
        label: 'Application Steps Incomplete Error',
        params: ['steps'],
    },
    // Notification Messages - Billing (use {{param}} for i18next interpolation)
    {
        key: 'notification.billing.chargeIncreased.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{chargeName}} Increased',
        label: 'Charge Increased Title',
        params: ['chargeName'],
    },
    {
        key: 'notification.billing.chargeIncreased.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{chargeName}} has increased from {{previousAmount}} to {{currentAmount}}.',
        label: 'Charge Increased Message',
        params: ['chargeName', 'previousAmount', 'currentAmount'],
    },
    {
        key: 'notification.billing.chargeDecreased.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{chargeName}} Decreased',
        label: 'Charge Decreased Title',
        params: ['chargeName'],
    },
    {
        key: 'notification.billing.chargeDecreased.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{chargeName}} has decreased from {{previousAmount}} to {{currentAmount}}.',
        label: 'Charge Decreased Message',
        params: ['chargeName', 'previousAmount', 'currentAmount'],
    },
    {
        key: 'notification.billing.chargeUpdated.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{chargeName}} Updated',
        label: 'Charge Updated Title',
        params: ['chargeName'],
    },
    {
        key: 'notification.billing.chargeUpdated.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{chargeName}} charge has been updated.',
        label: 'Charge Updated Message',
        params: ['chargeName'],
    },
    // Notification Messages - Verification
    {
        key: 'notification.verification.completed.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{verificationType}} Completed',
        label: 'Verification Completed Title',
        params: ['verificationType'],
    },
    {
        key: 'notification.verification.completed.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{verificationType}} has been successfully completed.',
        label: 'Verification Completed Message',
        params: ['verificationType'],
    },
    {
        key: 'notification.verification.failed.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{verificationType}} Failed',
        label: 'Verification Failed Title',
        params: ['verificationType'],
    },
    {
        key: 'notification.verification.failed.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{verificationType}} has failed. Please try again or contact support.',
        label: 'Verification Failed Message',
        params: ['verificationType'],
    },
    {
        key: 'notification.verification.reinitiated.title',
        category: SystemTranslationCategory.Notifications,
        defaultValue: '{{verificationType}} ReInitiated',
        label: 'Verification ReInitiated Title',
        params: ['verificationType'],
    },
    {
        key: 'notification.verification.reinitiated.message',
        category: SystemTranslationCategory.Notifications,
        defaultValue: 'Your {{verificationType}} has been reinitiated. Please try again or contact support.',
        label: 'Verification ReInitiated Message',
        params: ['verificationType'],
    },
    // Navigation (additional)
    {
        key: 'nav.backToHome',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Back to Home',
        label: 'Back to Home Button',
    },
    {
        key: 'nav.logout',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Logout',
        label: 'Logout Button',
    },
    {
        key: 'nav.loggingOut',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Logging out...',
        label: 'Logging Out Loader',
    },
    {
        key: 'nav.pleaseCompleteAllSteps',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Please complete all the steps before making a payment.',
        label: 'Please Complete All Steps Warning',
    },
    {
        key: 'nav.finalize',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Finalize',
        label: 'Finalize Button',
    },
    {
        key: 'nav.startNewApplication',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Start New Application',
        label: 'Start New Application Button',
    },
    {
        key: 'nav.select',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'Select',
        label: 'Select Button',
    },
    {
        key: 'nav.seeDetails',
        category: SystemTranslationCategory.Navigation,
        defaultValue: 'See Details',
        label: 'See Details Button',
    },
    // Floor Plan
    {
        key: 'floorPlan.selectAUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a Unit',
        label: 'Select a Unit Heading',
    },
    {
        key: 'floorPlan.selectFloorPlanAndUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a floor plan and unit',
        label: 'Select Floor Plan and Unit Subheading',
    },
    {
        key: 'floorPlan.noUnitsAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No units are available',
        label: 'No Units Available Message',
    },
    {
        key: 'floorPlan.noUnitsImmediatelyAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No units immediately available.',
        label: 'No Units Immediately Available Message',
    },
    {
        key: 'floorPlan.availableUnits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Available Units',
        label: 'Available Units Label',
    },
    {
        key: 'floorPlan.changeFloorPlan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Change Floor Plan',
        label: 'Change Floor Plan Button',
    },
    {
        key: 'floorPlan.changeUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Change Unit',
        label: 'Change Unit Button',
    },
    {
        key: 'floorPlan.changeOption',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Change Option',
        label: 'Change Option Button',
    },
    {
        key: 'floorPlan.unitsWithAvailableSpaces',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Units with Available Spaces',
        label: 'Units with Available Spaces Message',
    },
    {
        key: 'floorPlan.noUnitAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No unit available.',
        label: 'No Unit Available Message',
    },
    {
        key: 'floorPlan.errorRetrievingFloorPlanInformation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error retrieving floor plan information',
        label: 'Floor Plan Information Error',
    },
    {
        key: 'floorPlan.errorRetrievingAvailableUnits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error retrieving available units',
        label: 'Available Units Error',
    },
    {
        key: 'floorPlan.errorRetrievingAmenities',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error retrieving amenities',
        label: 'Amenities Error',
    },
    {
        key: 'floorPlan.changeSelection',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Change Selection',
        label: 'Change Selection Button',
    },
    {
        key: 'floorPlan.yourSelection',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your Selection',
        label: 'Your Selection Heading',
    },
    {
        key: 'floorPlan.bedroom',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bedroom',
        label: 'Bedroom (singular)',
    },
    {
        key: 'floorPlan.bedrooms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bedrooms',
        label: 'Bedrooms (plural)',
    },
    {
        key: 'floorPlan.bed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bed',
        label: 'Bed (singular)',
    },
    {
        key: 'floorPlan.beds',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Beds',
        label: 'Beds (plural)',
    },
    {
        key: 'floorPlan.bathroom',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bath',
        label: 'Bathroom (singular)',
    },
    {
        key: 'floorPlan.specials',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Specials',
        label: 'Specials Label',
    },
    {
        key: 'floorPlan.addOns',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add-Ons',
        label: 'Add-Ons Label',
    },
    {
        key: 'floorPlan.addOnImageAlt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add-on image',
        label: 'Add-On Image Alt Text',
    },
    {
        key: 'floorPlan.amenities',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Amenities',
        label: 'Amenities Label',
    },
    {
        key: 'floorPlan.propertyAmenity',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Property Amenity',
        label: 'Property Amenity Label',
    },
    {
        key: 'floorPlan.floorplanAmenity',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floorplan Amenity',
        label: 'Floorplan Amenity Label',
    },
    {
        key: 'floorPlan.unitAmenity',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Amenity',
        label: 'Unit Amenity Label',
    },
    {
        key: 'floorPlan.preferredAmenities',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Preferred Amenities',
        label: 'Preferred Amenities Label',
    },
    {
        key: 'floorPlan.preferredAmenitiesHelpText',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select your preferred amenities. Please note these amenities are not guaranteed. If you do receive any of these upon assignment to your unit space, any associated charges will be added at that time.',
        label: 'Preferred Amenities Help Text',
    },
    {
        key: 'floorPlan.description',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Description',
        label: 'Description Label',
    },
    {
        key: 'floorPlan.floor',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floor',
        label: 'Floor Column Header',
    },
    {
        key: 'floorPlan.sqFt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'SqFt',
        label: 'Square Feet Column Header',
    },
    {
        key: 'floorPlan.available',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Available',
        label: 'Available Column Header',
    },
    {
        key: 'floorPlan.unitSpaces',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Spaces',
        label: 'Unit Spaces Heading',
    },
    {
        key: 'floorPlan.space',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Space',
        label: 'Space Column Header',
    },
    {
        key: 'floorPlan.status',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Status',
        label: 'Status Column Header',
    },
    {
        key: 'floorPlan.notAuthorizedChangeUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You are not authorized to change unit.',
        label: 'Not Authorized to Change Unit Tooltip',
    },
    {
        key: 'floorPlan.notAuthorizedSelectUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You are not authorized to select unit.',
        label: 'Not Authorized to Select Unit Tooltip',
    },
    {
        key: 'floorPlan.unitNotAvailableTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Not Available',
        label: 'Unit Not Available Modal Title',
    },
    {
        key: 'floorPlan.unitNotAvailableForMoveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This unit is not available for the selected move-in date. This unit will be available on {{availableOn}}. Please update the move-in date.',
        label: 'Unit Not Available for Move-in Date Modal Message',
    },
    {
        key: 'floorPlan.updateMoveInDateAndSelectUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Update Move-in Date',
        label: 'Update Move-in Date and Select Unit Button',
    },
    // Payment
    {
        key: 'payment.convenienceFee',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Convenience Fee',
        label: 'Convenience Fee Label',
    },
    {
        key: 'payment.totalDue',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Total Due',
        label: 'Total Due Label',
    },
    {
        key: 'payment.recurringCharges',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Recurring Charges',
        label: 'Recurring Charges Section Title',
    },
    {
        key: 'payment.installments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Installments',
        label: 'Installments Section Title',
    },
    {
        key: 'payment.installment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Installment {{number}}',
        label: 'Installment Label',
        params: ['number'],
    },
    {
        key: 'payment.dueLater',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Due Later',
        label: 'Due Later Label',
    },
    {
        key: 'payment.installmentTotal',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Installment Total',
        label: 'Installment Total Label',
    },
    {
        key: 'payment.installmentChargeAmounts',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Recurring charge / installment total',
        label: 'Installment Charge Amounts Label',
    },
    {
        key: 'payment.discount',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Discount',
        label: 'Installment Discount Label',
    },
    {
        key: 'payment.premium',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Premium',
        label: 'Installment Premium Label',
    },
    {
        key: 'payment.week',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} week',
        label: 'Installment Duration Single Week',
        params: ['count'],
    },
    {
        key: 'payment.weeks',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} weeks',
        label: 'Installment Duration Multiple Weeks',
        params: ['count'],
    },
    {
        key: 'payment.day',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} day',
        label: 'Installment Duration Single Day',
        params: ['count'],
    },
    {
        key: 'payment.days',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} days',
        label: 'Installment Duration Multiple Days',
        params: ['count'],
    },
    {
        key: 'payment.month',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} month',
        label: 'Installment Duration Single Month',
        params: ['count'],
    },
    {
        key: 'payment.months',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} months',
        label: 'Installment Duration Multiple Months',
        params: ['count'],
    },
    {
        key: 'payment.dueNow',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Due Now',
        label: 'Due Now Section Title',
    },
    {
        key: 'payment.dueAtMoveIn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Due At Move-in',
        label: 'Due At Move-in Section Title',
    },
    {
        key: 'payment.selectUnitHint',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select a unit to make sure all of the details below are reflected accurately.',
        label: 'Select Unit Hint Text',
    },
    {
        key: 'payment.selectUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a Unit',
        label: 'Select a Unit Button (Payment)',
    },
    {
        key: 'payment.selectFloorplanHint',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select a floorplan to make sure all of the details below are reflected accurately',
        label: 'Select Floorplan Hint Text',
    },
    {
        key: 'payment.selectFloorplan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a Floorplan',
        label: 'Select a Floorplan Button (Payment)',
    },
    // Documents
    {
        key: 'documents.myDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'My Documents',
        label: 'My Documents Heading',
    },
    {
        key: 'documents.noDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You currently have no documents',
        label: 'No Documents Message',
    },
    {
        key: 'documents.leasePreferencesUnavailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to check whether a lease document is being prepared.',
        label: 'Lease Document Preferences Error',
    },
    {
        key: 'documents.checkingDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Checking for document...',
        label: 'Document Checking Status',
    },
    {
        key: 'documents.preparingDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: "We're preparing your document. It will appear here as soon as it's ready.",
        label: 'Document Preparation Message',
    },
    {
        key: 'documents.documentNotReady',
        category: SystemTranslationCategory.Common,
        defaultValue: "Your document isn't ready yet",
        label: 'Document Not Ready Status',
    },
    {
        key: 'documents.documentTakingLonger',
        category: SystemTranslationCategory.Common,
        defaultValue: "It's taking a little longer to prepare. Check again to see if it's ready.",
        label: 'Document Delay Message',
    },
    {
        key: 'documents.checkDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check document',
        label: 'Check Document Button',
    },
    {
        key: 'documents.checkingDocumentButton',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Checking document',
        label: 'Check Document Button Loading Text',
    },
    {
        key: 'documents.notYetSigned',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Not yet signed',
        label: 'Not Yet Signed Status',
    },
    {
        key: 'documents.open',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Open',
        label: 'Open Document Button',
    },
    {
        key: 'documents.view',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View',
        label: 'View Document Button',
    },
    {
        key: 'documents.agreed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Agreed',
        label: 'Document Agreed Status Prefix',
    },
    // Entry Page
    {
        key: 'entry.welcome',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Welcome',
        label: 'Welcome Text',
    },
    {
        key: 'entry.welcomeApplicant',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Welcome, {{name}}',
        label: 'Welcome Applicant Text',
        params: ['name'],
    },
    {
        key: 'entry.applicationsAndDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{propertyName}} Applications and Documents',
        label: 'Applications And Documents Heading',
        params: ['propertyName'],
    },
    {
        key: 'entry.initializingApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Initializing new application',
        label: 'Initializing Application Loader',
    },
    {
        key: 'entry.initializingApplicationError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error while initializing application.',
        label: 'Initializing Application Error',
    },
    {
        key: 'entry.applicationsFetchError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error fetching applicant applications',
        label: 'Applicant Applications Fetch Error',
    },
    {
        key: 'entry.myApplications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'My Applications',
        label: 'My Applications Heading',
    },
    {
        key: 'entry.waitlistOffers',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Waitlist Offers',
        label: 'Waitlist Offers Heading',
    },
    {
        key: 'entry.selectApplicationType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select an application type',
        label: 'Select Application Type Heading',
    },
    {
        key: 'entry.continueButton',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Continue',
        label: 'Continue Button',
    },
    {
        key: 'entry.offersAndActions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Offers & Actions',
        label: 'Offers & Actions Heading',
    },
    {
        key: 'entry.requiredSection',
        category: SystemTranslationCategory.Common,
        defaultValue: 'REQUIRED',
        label: 'Required Section Label',
    },
    {
        key: 'entry.rentersInsuranceTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Renters Insurance',
        label: 'Renters Insurance Card Title',
    },
    {
        key: 'entry.rentersInsuranceRequiredTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Renters Insurance Required',
        label: 'Renters Insurance Required Card Title',
    },
    {
        key: 'entry.rentersInsuranceDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: "Proof of renter's insurance is required before move-in.",
        label: 'Renters Insurance Required Card Description',
    },
    {
        key: 'entry.rentersInsuranceSuccessDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: "Proof of renter's insurance is on file.",
        label: 'Renters Insurance Success Card Description',
    },
    {
        key: 'entry.rentersInsuranceCardAriaLabelRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Renters insurance required. Complete enrollment.',
        label: 'Renters Insurance Card Aria Label (Required)',
    },
    {
        key: 'entry.rentersInsuranceCardAriaLabelSuccess',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Renters insurance verified. View details.',
        label: 'Renters Insurance Card Aria Label (Success)',
    },
    {
        key: 'entry.rentersInsuranceRequiredBadge',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Required',
        label: 'Renters Insurance Required Badge',
    },
    {
        key: 'entry.rentersInsuranceSuccessBadge',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Success',
        label: 'Renters Insurance Success Badge',
    },
    // Thank You Page
    {
        key: 'thankYou.heading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Thank you',
        label: 'Thank You Page Heading',
    },
    {
        key: 'thankYou.viewApplicationStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View Application Status',
        label: 'View Application Status Button',
    },
    {
        key: 'thankYou.closeWindow',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You can close this window.',
        label: 'Close Window Message',
    },
    // Floor Plan (additional)
    {
        key: 'floorPlan.rent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Rent',
        label: 'Rent Label',
    },
    {
        key: 'floorPlan.rentWithFrequency',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{amount}} {{frequency}}',
        label: 'Rent Frequency',
    },
    {
        key: 'floorPlan.deposit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Deposit',
        label: 'Deposit Label',
    },
    {
        key: 'floorPlan.layout',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Layout',
        label: 'Layout Label',
    },
    {
        key: 'floorPlan.quickView',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Quick View',
        label: 'Floor Plan Quick View Button',
    },
    {
        key: 'floorPlan.bathrooms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bathrooms',
        label: 'Bathrooms Label',
    },
    {
        key: 'floorPlan.minRent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Min. rent',
        label: 'Minimum Rent Filter Label',
    },
    {
        key: 'floorPlan.maxRent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Max. rent',
        label: 'Maximum Rent Filter Label',
    },
    {
        key: 'floorPlan.sqFeet',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sq.feet',
        label: 'Square Feet Filter Label',
    },
    {
        key: 'floorPlan.searchByName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Search by name',
        label: 'Search By Name Filter Label',
    },
    {
        key: 'floorPlan.spaceOption',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Space option',
        label: 'Space Option Filter Label',
    },
    {
        key: 'floorPlan.allSpaceOptions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'All space options',
        label: 'Space Option Filter Default',
    },
    {
        key: 'floorPlan.all',
        category: SystemTranslationCategory.Common,
        defaultValue: 'All',
        label: 'All Floor Plan Counts',
    },
    {
        key: 'floorPlan.apply',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Apply',
        label: 'Apply Filter Button',
    },
    {
        key: 'floorPlan.floorPlanFilters',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floor Plan Filters',
        label: 'Floor Plan Filters Heading',
    },
    {
        key: 'floorPlan.filter',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Filter',
        label: 'Filter Button',
    },
    {
        key: 'floorPlan.showAdvanced',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Show Advanced',
        label: 'Show Advanced Filters Button',
    },
    {
        key: 'floorPlan.moveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-in date',
        label: 'Move-In Date Label',
    },
    {
        key: 'floorPlan.immediateMoveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Immediate Move-in Date',
        label: 'Immediate Move-In Date Label',
    },
    {
        key: 'floorPlan.selectAFloorPlan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a Floor Plan',
        label: 'Select a Floor Plan Heading',
    },
    {
        key: 'floorPlan.selectFloorPlanInstructions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select your desired floor plan, unit, and options.',
        label: 'Select Floor Plan Instructions',
    },
    {
        key: 'floorPlan.unitSpecials',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Specials',
        label: 'Unit Specials Label',
    },
    {
        key: 'floorPlan.selectALeaseTerm',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select from Available Lease Terms',
        label: 'Select Lease Term Heading',
    },
    {
        key: 'floorPlan.academicYearLeaseTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Academic Year / Lease Terms',
        label: 'Academic Year and Lease Terms Heading',
    },
    {
        key: 'floorPlan.selectAcademicYear',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select academic year',
        label: 'Select Academic Year Label',
    },
    {
        key: 'floorPlan.noLeaseTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'There are no lease terms available. Please select another unit.',
        label: 'No Lease Terms Message',
    },
    {
        key: 'floorPlan.noAcademicYearsAssociated',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Academic years are not set up for this property.',
        label: 'No Academic Years Associated Message',
    },
    {
        key: 'floorPlan.leaseTermSelectionError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This lease term has some issue please select another lease term',
        label: 'Lease Term Selection Error',
    },
    {
        key: 'floorPlan.moveInDateMustBeBetween',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-in date must be between {{startDate}} and {{endDate}}.',
        label: 'Move-in Date Range Error',
        params: ['startDate', 'endDate'],
    },
    {
        key: 'floorPlan.failedToLoadLeaseTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to load lease terms.',
        label: 'Failed to Load Lease Terms Error',
    },
    {
        key: 'floorPlan.noLeaseTermsAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No lease terms available.',
        label: 'No Lease Terms Available Message',
    },
    {
        key: 'floorPlan.selectDatePlaceholder',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select date',
        label: 'Select Date Placeholder',
    },
    {
        key: 'floorPlan.unitNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Number',
        label: 'Unit Number Column Header',
    },
    {
        key: 'floorPlan.building',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Building',
        label: 'Building Column Header',
    },
    {
        key: 'floorPlan.priceColumn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Price (12 Month Lease)',
        label: 'Price Column Header',
    },
    {
        key: 'floorPlan.notAuthorizedChange',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You are not authorized to change.',
        label: 'Not Authorized to Change Tooltip',
    },
    // Payment (additional)
    {
        key: 'payment.transfermate.paymentDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Details',
        label: 'TransferMate Payment Details Heading',
    },
    {
        key: 'payment.transfermate.paymentMethod',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Method',
        label: 'TransferMate Payment Method Label',
    },
    {
        key: 'payment.transfermate.studentInformation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Student Information',
        label: 'TransferMate Student Information Heading',
    },
    {
        key: 'payment.transfermate.payerInformation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payer Information',
        label: 'TransferMate Payer Information Heading',
    },
    {
        key: 'payment.transfermate.feeDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Fee Description',
        label: 'TransferMate Fee Description Label',
    },
    {
        key: 'payment.transfermate.educationInstituteName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Education Institute Name',
        label: 'TransferMate Education Institute Name Label',
    },
    {
        key: 'payment.transfermate.whoIsMakingPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Who is making the payment?',
        label: 'TransferMate Payer Selection Label',
    },
    {
        key: 'payment.transfermate.selectWhoIsMakingPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select who is making the payment',
        label: 'TransferMate Payer Selection Placeholder',
    },
    {
        key: 'payment.transfermate.studentName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Student Name',
        label: 'TransferMate Student Name Label',
    },
    {
        key: 'payment.transfermate.studentChineseName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Student Chinese Name',
        label: 'TransferMate Student Chinese Name Label',
    },
    {
        key: 'payment.transfermate.invalidChineseName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Enter valid Chinese name (1–50 Chinese characters)',
        label: 'TransferMate Chinese Name Validation',
    },
    {
        key: 'payment.transfermate.dateOfBirth',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Date of Birth',
        label: 'TransferMate Date of Birth Label',
    },
    {
        key: 'payment.phoneNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Phone Number',
        label: 'Payment Phone Number Label',
    },
    {
        key: 'payment.phoneCountryCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Phone country code',
        label: 'Payment Phone Country Code Label',
    },
    {
        key: 'payment.transfermate.studentIdNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Student ID Number',
        label: 'TransferMate Student ID Label',
    },
    {
        key: 'payment.transfermate.documentLabel.cpf',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CPF',
        label: 'TransferMate CPF Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.citizenIdNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Citizen ID Number',
        label: 'TransferMate Citizen ID Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.dniOrCuit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'DNI or CUIT',
        label: 'TransferMate DNI or CUIT Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.ci',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CI',
        label: 'TransferMate CI Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.ciRut',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CI/RUT',
        label: 'TransferMate CI/RUT Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.cc',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CC',
        label: 'TransferMate CC Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.id',
        category: SystemTranslationCategory.Common,
        defaultValue: 'ID',
        label: 'TransferMate ID Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.nik',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NIK',
        label: 'TransferMate NIK Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.payerPan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payer PAN',
        label: 'TransferMate Payer PAN Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.curp',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CURP',
        label: 'TransferMate CURP Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.cnie',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CNIE',
        label: 'TransferMate CNIE Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.nin',
        category: SystemTranslationCategory.Common,
        defaultValue: 'NIN',
        label: 'TransferMate NIN Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.dni',
        category: SystemTranslationCategory.Common,
        defaultValue: 'DNI',
        label: 'TransferMate DNI Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.tcKimlikNo',
        category: SystemTranslationCategory.Common,
        defaultValue: 'T.C. Kimlik No.',
        label: 'TransferMate T.C. Kimlik Document Label',
    },
    {
        key: 'payment.transfermate.documentLabel.ssn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'SSN',
        label: 'TransferMate SSN Document Label',
    },
    {
        key: 'payment.transfermate.documentHelper.cpf',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 11 digit number. Ex:123.456.789-10',
        label: 'TransferMate CPF Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.eighteenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 18 digits',
        label: 'TransferMate 18 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.sevenNineOrElevenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 7, 9 or 11 digits',
        label: 'TransferMate 7, 9 or 11 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 5 to 20 digits',
        label: 'TransferMate 5 to 20 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.eightOrNineDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 8 or 9 digits',
        label: 'TransferMate 8 or 9 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.sixToTenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 6 to 10 digits',
        label: 'TransferMate 6 to 10 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.fourteenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 14 digits',
        label: 'TransferMate 14 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.sixteenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 16 digits',
        label: 'TransferMate 16 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.pan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 10 digits. Ex:AAAAA1234A',
        label: 'TransferMate PAN Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.tenToEighteenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 10 to 18 digits',
        label: 'TransferMate 10 to 18 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.elevenDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 11 digits',
        label: 'TransferMate 11 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.ssn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 9 digits. Ex:123-45-6789',
        label: 'TransferMate SSN Document Helper',
    },
    {
        key: 'payment.transfermate.documentHelper.sixToEightDigits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This should be 6 to 8 digits',
        label: 'TransferMate 6 to 8 Digit Document Helper',
    },
    {
        key: 'payment.transfermate.payerName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payer Name',
        label: 'TransferMate Payer Name Label',
    },
    {
        key: 'payment.transfermate.relationshipToStudent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Relationship to Student',
        label: 'TransferMate Relationship Label',
    },
    {
        key: 'payment.transfermate.sourceOfFund',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Source of Fund',
        label: 'TransferMate Source of Fund Label',
    },
    {
        key: 'payment.transfermate.selectSourceOfFund',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select Source of Fund',
        label: 'TransferMate Source of Fund Placeholder',
    },
    {
        key: 'payment.transfermate.declarationAmount',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Declaration Amount',
        label: 'TransferMate Declaration Amount Label',
    },
    {
        key: 'payment.transfermate.payerPan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payer PAN',
        label: 'TransferMate Payer PAN Label',
    },
    {
        key: 'payment.transfermate.fxLimitQuestion',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Will you exceed the US $250,000 foreign exchange limit in the financial year April 1–March 31?',
        label: 'TransferMate FX Limit Question',
    },
    {
        key: 'payment.transfermate.yes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yes',
        label: 'TransferMate Yes Option',
    },
    {
        key: 'payment.transfermate.no',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No',
        label: 'TransferMate No Option',
    },
    {
        key: 'payment.transfermate.indiaDeclarationHelp',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Enter the cumulative INR value of foreign exchange transactions made during the current financial year (April 1–March 31).',
        label: 'TransferMate India Declaration Help',
    },
    {
        key: 'payment.transfermate.fxLimitRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This field is required',
        label: 'TransferMate FX Limit Required Error',
    },
    {
        key: 'payment.transfermate.countryRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Country is required',
        label: 'TransferMate Country Required Error',
    },
    {
        key: 'payment.transfermate.sourceOfFundRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Source of fund is required',
        label: 'TransferMate Source of Fund Required Error',
    },
    {
        key: 'payment.transfermate.declarationAmountRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Enter a valid declaration amount',
        label: 'TransferMate Declaration Amount Required Error',
    },
    {
        key: 'payment.transfermate.panRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Enter a valid 10-character payer PAN',
        label: 'TransferMate PAN Required Error',
    },
    {
        key: 'payment.transfermate.noPaymentMethods',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Card is not supported for the selected country.',
        label: 'TransferMate No Payment Methods Message',
    },
    {
        key: 'payment.transfermate.fxError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to load payment options. Please try again.',
        label: 'TransferMate FX Error Message',
    },
    {
        key: 'payment.transfermate.terms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'TransferMate student terms of use',
        label: 'TransferMate Terms Link Label',
    },
    {
        key: 'payment.transfermate.termsText',
        category: SystemTranslationCategory.Common,
        defaultValue: 'I understand that my payment will be processed by TransferMate, and I agree to be bound by the',
        label: 'TransferMate Terms Checkbox Text',
    },
    {
        key: 'payment.paymentTermsLink',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Terms & Conditions',
        label: 'Payment Terms Link Label',
    },
    {
        key: 'payment.transfermate.bacsDisclaimer',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You will be redirected to Stripe Checkout to finalize your payment. Please note, paying via Bacs Direct Debit will authorise the property to automatically debit your account for this and any future charges.',
        label: 'BACS Auto Payment Disclaimer',
    },
    {
        key: 'payment.applicationCompletionDisclaimer',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your application will be completed once we receive confirmation of your payment. Thank you.',
        label: 'Application Completion Disclaimer',
    },
    {
        key: 'payment.international.termsRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please agree to the terms and conditions',
        label: 'International Payment Terms Required Error',
    },
    {
        key: 'payment.international.unavailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This payment page has not been activated for your account yet. No transaction has been attempted, and your account has not been charged.',
        label: 'International Payment Unavailable Message',
    },
    {
        key: 'payment.international.methodNotAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The selected payment method is not available for payment yet.',
        label: 'International Payment Method Unavailable Error',
    },
    {
        key: 'payment.international.handoffFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We could not restore your application. Retry to continue your existing payment.',
        label: 'Payment Handoff Recovery Error',
    },
    {
        key: 'payment.international.checkoutUnconfirmed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your payment is processing or could not be confirmed. Retry to check its status. Contact the property before starting another payment.',
        label: 'Checkout Status Unconfirmed',
    },
    {
        key: 'payment.international.recoveryHeading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Continue your application',
        label: 'Payment Recovery Heading',
    },
    {
        key: 'payment.international.restartAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your application is saved. Payment checkout has not started. Return to your application to review your details and finalize again.',
        label: 'Payment Restart Available',
    },
    {
        key: 'payment.international.continueExisting',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your application is saved. Continue your existing payment securely through Stripe.',
        label: 'Continue Existing Payment Description',
    },
    {
        key: 'payment.international.recoveryPending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We could not confirm your payment status. Your application is saved. Check the status again, or contact the property with the reference below if this continues. Please do not start a separate payment.',
        label: 'Payment Recovery Pending',
    },
    {
        key: 'payment.international.continuePayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Continue payment',
        label: 'Continue Payment Action',
    },
    {
        key: 'payment.international.returnToApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Return to application',
        label: 'Return To Application Action',
    },
    {
        key: 'payment.international.checkPaymentStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check payment status',
        label: 'Check Payment Status Action',
    },
    {
        key: 'payment.international.paymentReference',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment reference: {{reference}}',
        label: 'Payment Support Reference',
    },
    {
        key: 'payment.international.paymentFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your payment could not be completed. Please try again.',
        label: 'International Payment Failed Error',
    },
    {
        key: 'payment.international.paymentIdMismatch',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Invalid transaction.',
        label: 'International Payment ID Mismatch Error',
    },
    {
        key: 'payment.international.paymentCancelled',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment has not been processed yet. Please try again.',
        label: 'International Payment Cancelled Error',
    },
    {
        key: 'payment.international.transferMatePending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your TransferMate payment is still processing. Please try again later.',
        label: 'TransferMate Payment Pending Message',
    },
    {
        key: 'payment.alreadyProcessed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment has already been made. Completing your application.',
        label: 'Payment Already Processed Message',
    },
    {
        key: 'payment.statusCheckFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to confirm your payment status. Please try again.',
        label: 'Payment Status Check Error',
    },
    {
        key: 'payment.international.processing',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Processing payment',
        label: 'International Payment Processing Label',
    },
    {
        key: 'payment.international.verifying',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verifying your payment',
        label: 'International Payment Verification Label',
    },
    {
        key: 'payment.international.transferMateNotAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'TransferMate card payment processing is not available yet.',
        label: 'TransferMate Payment Unavailable Error',
    },
    {
        key: 'payment.international.transferMateFieldsRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please complete all required TransferMate fields.',
        label: 'TransferMate Fields Required Error',
    },
    {
        key: 'payment.international.invalidAmount',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please provide a valid payment amount.',
        label: 'International Payment Amount Error',
    },
    {
        key: 'payment.international.invalidStripeResponse',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to start the Stripe payment. Please try again.',
        label: 'Stripe Payment Start Error',
    },
    {
        key: 'payment.international.invalidTransferMateResponse',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to start the TransferMate payment. Please try again.',
        label: 'TransferMate Payment Start Error',
    },
    {
        key: 'payment.international.transferMatePaymentFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to process the TransferMate payment. Please try again.',
        label: 'TransferMate Payment Processing Error',
    },
    {
        key: 'payment.paymentInformation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Information',
        label: 'Payment Information Heading',
    },
    {
        key: 'payment.chargesDue',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Charges Due Now',
        label: 'Charges Due Now Label',
    },
    {
        key: 'payment.paymentConfirmed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Confirmed',
        label: 'Payment Confirmed Heading',
    },
    {
        key: 'payment.paymentCompleted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Completed',
        label: 'Payment Completed Heading (Lead Profile)',
    },
    {
        key: 'payment.paymentDone',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment is Done',
        label: 'Payment Already Processed Message',
    },
    {
        key: 'payment.noAmountDue',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No payment is due.',
        label: 'No Amount Due Message',
    },
    {
        key: 'payment.noPaymentOptionAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No payment option available',
        label: 'No Payment Option Available Message',
    },
    {
        key: 'payment.pleaseContactPropertyManager',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please contact property manager',
        label: 'Please contact property manager Message',
    },
    {
        key: 'payment.noPaymentOptionsError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No payment option available. Please contact property manager.',
        label: 'No Payment Options Alert with Contact Manager Instruction',
    },
    {
        key: 'payment.paymentPending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Pending',
        label: 'Payment Pending Heading',
    },
    {
        key: 'payment.savePDF',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Save PDF',
        label: 'Save PDF Button',
    },
    {
        key: 'payment.print',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Print',
        label: 'Print Button',
    },
    {
        key: 'payment.accountHolder',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Account Holder',
        label: 'Account Holder Label',
    },
    {
        key: 'payment.cardHolder',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Card Holder',
        label: 'Card Holder Label',
    },
    {
        key: 'payment.agreeToFees',
        category: SystemTranslationCategory.Common,
        defaultValue: 'I agree to the fees listed and have read and accept the',
        label: 'Agree to Fees Checkbox Label',
    },
    {
        key: 'payment.processedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your payment has been successfully processed with {{cardType}} ending in {{last4}}',
        label: 'Payment Processed Message',
        params: ['cardType', 'last4'],
    },
    {
        key: 'payment.completedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The applicants application payment has been successfully processed.',
        label: 'Payment Completed Message',
    },
    {
        key: 'payment.pendingMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The applicant has not completed the payment.',
        label: 'Payment Pending Message',
    },
    {
        key: 'payment.noPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No payment',
        label: 'No Payment Heading',
    },
    {
        key: 'payment.noPaymentMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment has not been started.',
        label: 'No Payment Message',
    },
    {
        key: 'payment.errorLoadingPage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error while loading payments page',
        label: 'Error Loading Payments Page',
    },
    {
        key: 'payment.errorOnLoadingPaymentMethod',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Something went wrong on our end. Please try again in a few moments.',
        label: 'Something went wrong on our end. Please try again in a few moments.',
    },
    {
        key: 'payment.holderInformationHeading',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{title}} Information',
        label: 'Holder Information Heading',
    },
    {
        key: 'payment.identityVerificationNote',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This information is required to verify identity. It will only be required when adding new payment methods.',
        label: 'Identity Verification Note',
    },
    {
        key: 'payment.holderInfoSameAsApplicant',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{title}} info is the same as the applicant.',
        label: 'Holder Info Same As Applicant',
    },
    {
        key: 'payment.holderNoMiddleName',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{title}} does not have a middle name.',
        label: 'Holder No Middle Name',
    },
    {
        key: 'payment.holderDateOfBirth',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{title}} Date of Birth',
        label: 'Holder Date of Birth',
    },
    {
        key: 'payment.firstName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'First Name',
        label: 'Payment First Name',
    },
    {
        key: 'payment.middleName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Middle Name',
        label: 'Payment Middle Name',
    },
    {
        key: 'payment.lastName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Last Name',
        label: 'Payment Last Name',
    },
    {
        key: 'payment.countryRegion',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Country/Region',
        label: 'Country/Region',
    },
    {
        key: 'payment.unitedStates',
        category: SystemTranslationCategory.Common,
        defaultValue: 'United States',
        label: 'United States',
    },
    {
        key: 'payment.addressLine1',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Address Line 1',
        label: 'Address Line 1',
    },
    {
        key: 'payment.addressLine2',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Address Line 2',
        label: 'Address Line 2',
    },
    {
        key: 'payment.city',
        category: SystemTranslationCategory.Common,
        defaultValue: 'City',
        label: 'Payment City',
    },
    {
        key: 'payment.state',
        category: SystemTranslationCategory.Common,
        defaultValue: 'State',
        label: 'Payment State',
    },
    {
        key: 'payment.zip',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Zip',
        label: 'Payment Zip',
    },
    {
        key: 'payment.securePaymentMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payments stored and processed securely with TLS / PCI',
        label: 'Secure Payment Message',
    },
    {
        key: 'payment.cardNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Card Number',
        label: 'Card Number',
    },
    {
        key: 'payment.nameOnCard',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Name on card',
        label: 'Name on Card',
    },
    {
        key: 'payment.expiryDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Exp. Date',
        label: 'Expiry Date',
    },
    {
        key: 'payment.cvv',
        category: SystemTranslationCategory.Common,
        defaultValue: 'CVV',
        label: 'CVV',
    },
    {
        key: 'payment.billingZipCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Billing Zip Code',
        label: 'Billing Zip Code',
    },
    {
        key: 'payment.linkBankAccount',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Link Bank Account',
        label: 'Link Bank Account',
    },
    {
        key: 'payment.launchingPlaid',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Launching Plaid',
        label: 'Launching Plaid Loader',
    },
    {
        key: 'payment.previewModeDisabled',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This button is disabled on preview mode.',
        label: 'Preview Mode Disabled Tooltip',
    },
    {
        key: 'payment.deleteAccountConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you want to delete this account?',
        label: 'Delete Account Confirmation',
    },
    {
        key: 'payment.plaidRedirectNotice',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You will be redirected to our third party partner, Plaid, to link your bank account in order to keep your payments secure and private.',
        label: 'Plaid Redirect Notice',
    },
    {
        key: 'payment.continueToPlaid',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Continue to Plaid',
        label: 'Continue to Plaid Button',
    },
    // Documents (additional)
    {
        key: 'documents.signingDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Signing document...',
        label: 'Signing Document Loader',
    },
    {
        key: 'documents.loadingDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading documents...',
        label: 'Loading Documents Loader',
    },
    {
        key: 'documents.viewingDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading document...',
        label: 'Viewing Document Loader',
    },
    {
        key: 'documents.processingDocumentAgreement',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Processing document agreement...',
        label: 'Processing Document Agreement Loader',
    },
    {
        key: 'documents.loadingNextDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading next document...',
        label: 'Loading Next Document Loader',
    },
    {
        key: 'documents.failedToGenerate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to generate documents',
        label: 'Failed to Generate Documents Error',
    },
    {
        key: 'documents.retry',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Retry',
        label: 'Retry Button',
    },
    {
        key: 'documents.generating',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Generating...',
        label: 'Generating Status',
    },
    {
        key: 'documents.signAndComplete',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sign & Complete',
        label: 'Sign and Complete Button',
    },
    {
        key: 'documents.signAndNext',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sign & Next',
        label: 'Sign and Next Button',
    },
    {
        key: 'documents.documentsToReview',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Documents to Review and Initial',
        label: 'Documents to Review Label',
    },
    {
        key: 'documents.affordableDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Affordable Documents',
        label: 'Affordable Documents Heading',
    },
    {
        key: 'documents.agreeToTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'I agree to the terms of this policy',
        label: 'Agree to Terms Checkbox',
    },
    {
        key: 'documents.download',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Download',
        label: 'Download Button',
    },
    {
        key: 'documents.viewSignedDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View Signed Document',
        label: 'View Signed Document Button',
    },
    {
        key: 'documents.signDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sign Document',
        label: 'Sign Document Button',
    },
    {
        key: 'documents.downloadDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Download Document',
        label: 'Download Document Button',
    },
    {
        key: 'documents.incomplete',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Incomplete',
        label: 'Incomplete Document Badge',
    },
    {
        key: 'documents.signed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Signed',
        label: 'Signed Document Status Prefix',
    },
    {
        key: 'documents.notSigned',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Not Signed',
        label: 'Not Signed Document Status',
    },
    {
        key: 'documents.digitalSignatureAgreement',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Digital Signature Agreement',
        label: 'Digital Signature Agreement Heading',
    },
    {
        key: 'documents.agreeAndSign',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Agree & Sign',
        label: 'Agree And Sign Button',
    },
    {
        key: 'documents.allPoliciesMustBeViewed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'All policy documents must be viewed and agreed to before submitting the application',
        label: 'All Policies Must Be Viewed Warning',
    },
    {
        key: 'documents.errorGeneratingDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'An error was encountered generating policy documents.',
        label: 'Error Generating Documents Message',
    },
    {
        key: 'documents.noPolicyDocumentsAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No policy document available',
        label: 'No Policy Document Available Message',
    },
    {
        key: 'documents.complianceNoticeHeading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Compliance Notice',
        label: 'Compliance Notice Heading',
    },
    {
        key: 'documents.electronicAgreementHeading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Electronic Agreement',
        label: 'Electronic Agreement Heading',
    },
    {
        key: 'documents.agreeToElectronicTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yes, I agree to the Terms and Conditions of Electronic Document Delivery',
        label: 'Agree to Electronic Terms Checkbox',
    },
    {
        key: 'documents.pleaseTypeYourName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please Type Your Name:',
        label: 'Please Type Your Name Label',
    },
    {
        key: 'documents.pleaseTypeFullName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please type your first and last name as it appears on your application',
        label: 'Please Type Full Name Instruction',
    },
    {
        key: 'documents.errorSubmittingSignature',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error submitting digital signature.',
        label: 'Error Submitting Signature Message',
    },
    {
        key: 'documents.insuranceCriteriaFetchError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to verify insurance requirements. Please try again.',
        label: 'Insurance criteria check failed after lease signing',
    },
    {
        key: 'documents.electronicSignatureLegalNotice',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Electronic signatures have the same legal effect as ink signatures on hard copies. By typing my name in the following box I certify the above statements to be true and correct, to the best of my knowledge. <bold>Electronic Signatures</bold> - By initialing next to the policy documents above and typing your name in the box below you are explicitly indicating that you have <bold>read</bold> and that you <bold>agree</bold> to terms and conditions of this application and the terms and conditions of the policy documents, and that you have signed them electronically.',
        label: 'Electronic Signature Legal Notice',
    },
    // Summary Page
    {
        key: 'summary.occupants',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Occupants',
        label: 'Occupants Section Heading',
    },
    {
        key: 'summary.guarantors',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantors',
        label: 'Guarantors Section Heading',
    },
    {
        key: 'summary.missingRequiredFields',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You are missing required fields.',
        label: 'Missing Required Fields Message',
    },
    {
        key: 'summary.clickToFixErrors',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Click here to fix errors',
        label: 'Click to Fix Errors Link',
    },
    {
        key: 'summary.verificationStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verification Status',
        label: 'Verification Status Heading',
    },
    {
        key: 'summary.idVerification',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Id Verification',
        label: 'ID Verification Label',
    },
    {
        key: 'summary.incomeVerification',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income Verification',
        label: 'Income Verification Label',
    },
    {
        key: 'summary.checkStatusWithCountdown',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check Status ({{countdown}}s)',
        label: 'Check Status Button with Countdown',
        params: ['countdown'],
    },
    {
        key: 'summary.checkStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check Status',
        label: 'Check Status Button',
        params: ['countdown'],
    },
    {
        key: 'summary.digitalSignature',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Digital Signature',
        label: 'Digital Signature Field Label',
    },
    {
        key: 'summary.typeSignaturePlaceholder',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Type your signature',
        label: 'Type Signature Placeholder',
    },
    {
        key: 'summary.pleaseType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please type: ',
        label: 'Please Type Label',
    },
    {
        key: 'summary.signatureRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Signature is required',
        label: 'Signature Required Error',
    },
    {
        key: 'summary.signatureMustMatch',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Signature must match your name as it appears on the application',
        label: 'Signature Must Match Error',
    },
    {
        key: 'summary.coApplicantSignNotice',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Co-applicants and guarantors must view and sign policy documents before the application can be submitted.',
        label: 'Co-Applicant Sign Notice',
    },
    {
        key: 'summary.failedToFetchCharges',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to fetch charges',
        label: 'Failed to Fetch Charges Error',
    },
    {
        key: 'summary.pending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pending',
        label: 'Pending Status',
    },
    {
        key: 'summary.notStarted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Not Started',
        label: 'Not Started Status',
    },
    {
        key: 'summary.inProgress',
        category: SystemTranslationCategory.Common,
        defaultValue: 'In Progress',
        label: 'In Progress Status',
    },
    {
        key: 'summary.success',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Success',
        label: 'Success Status',
    },
    {
        key: 'summary.failed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed',
        label: 'Failed Status',
    },
    // Shopping Cart
    {
        key: 'cart.yourNewHome',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your New Home',
        label: 'Your New Home Heading',
    },
    {
        key: 'cart.chargesDue',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Charges Due',
        label: 'Charges Due Section Label',
    },
    {
        key: 'cart.shoppingCart',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Shopping Cart',
        label: 'Shopping Cart Button Label',
    },
    {
        key: 'cart.totalDue',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Total Due',
        label: 'Total Due Label (Cart)',
    },
    {
        key: 'cart.average',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Average',
        label: 'Average Label',
    },
    {
        key: 'cart.varies',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Varies',
        label: 'Varies Label',
    },
    {
        key: 'cart.amountVariesByUsage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Amount Varies By Usage',
        label: 'Amount Varies By Usage Label',
    },
    {
        key: 'cart.utilityResponsibilities',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Utility Responsibilities',
        label: 'Utility Responsibilities Label',
    },
    {
        key: 'cart.specialPromotions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Special Promotions',
        label: 'Special Promotions Heading',
    },
    {
        key: 'cart.promoCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Promo Code',
        label: 'Promo Code Label',
    },
    {
        key: 'cart.promoCodeCartPrompt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Have a promo code?',
        label: 'Mobile Promo Code Cart Prompt',
    },
    {
        key: 'cart.applyCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Apply Code',
        label: 'Apply Promo Code Button',
    },
    {
        key: 'cart.invalidPromoCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The promo code you entered is invalid. Please try again.',
        label: 'Invalid Promo Code Error',
    },
    {
        key: 'cart.moveIn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-In',
        label: 'Move-In Label',
    },
    {
        key: 'cart.leaseTermSummaryWithFrequency',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{term}} Month Lease - {{amount}} {{frequency}}',
        label: 'Selected Lease Term Summary With Frequency',
        params: ['term', 'amount', 'frequency'],
    },
    {
        key: 'cart.floorplan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floorplan',
        label: 'Floorplan Label',
    },
    {
        key: 'cart.waitlisted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Waitlisted',
        label: 'Waitlisted Status Badge',
    },
    {
        key: 'cart.failedToLoadFloorPlans',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to load floor plans. Please try again later.',
        label: 'Failed to Load Floor Plans Error',
    },
    {
        key: 'cart.loadingCharges',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading charges',
        label: 'Loading Charges',
    },
    {
        key: 'cart.updatingCharges',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Updating charges',
        label: 'Updating Charges',
    },
    {
        key: 'cart.timing',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Timing',
        label: 'Timing Label',
    },
    {
        key: 'cart.frequency',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Frequency',
        label: 'Frequency Label',
    },
    {
        key: 'cart.method',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Method',
        label: 'Method Label',
    },
    {
        key: 'cart.total',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Total',
        label: 'Cart Section Total Label',
    },
    {
        key: 'cart.chargeFrequency.hourly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Hourly',
        label: 'Hourly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.daily',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Daily',
        label: 'Daily Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.weekly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Weekly',
        label: 'Weekly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.everyTwoWeeks',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Every Two Weeks',
        label: 'Every Two Weeks Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.twicePerMonth',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Twice Per Month',
        label: 'Twice Per Month Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.specificLeaseMonths',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Specific Lease Months',
        label: 'Specific Lease Months Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.monthly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly',
        label: 'Monthly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.quarterly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Quarterly',
        label: 'Quarterly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.twicePerYear',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Twice Per Year',
        label: 'Twice Per Year Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.yearly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yearly',
        label: 'Yearly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.percentOfSales',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Percent Of Sales',
        label: 'Percent Of Sales Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.nightly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Nightly',
        label: 'Nightly Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perMonth',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Month',
        label: 'Per Month Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perHour',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Hour',
        label: 'Per Hour Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perDay',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Day',
        label: 'Per Day Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perQuarter',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Quarter',
        label: 'Per Quarter Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perOccurrence',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Occurrence',
        label: 'Per Occurrence Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.oneTime',
        category: SystemTranslationCategory.Common,
        defaultValue: 'One-Time',
        label: 'One-Time Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perYear',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Year',
        label: 'Per Year Charge Frequency',
    },
    {
        key: 'cart.chargeFrequency.perInstallment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Installment',
        label: 'Per Installment Charge Frequency',
    },
    {
        key: 'cart.chargeTiming.atMoveIn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'At Move-In',
        label: 'At Move-In Charge Timing',
    },
    {
        key: 'cart.chargeTiming.atApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'At Application',
        label: 'At Application Charge Timing',
    },
    {
        key: 'cart.chargeTiming.atMoveOut',
        category: SystemTranslationCategory.Common,
        defaultValue: 'At Move-Out',
        label: 'At Move-Out Charge Timing',
    },
    {
        key: 'cart.chargeTiming.monthly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly',
        label: 'Monthly Charge Timing',
    },
    {
        key: 'cart.chargeTiming.occasional',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Occasional',
        label: 'Occasional Charge Timing',
    },
    {
        key: 'cart.chargeTiming.perLease',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Lease',
        label: 'Per Lease Charge Timing',
    },
    {
        key: 'cart.chargeTiming.recurring',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Recurring',
        label: 'Recurring Charge Timing',
    },
    {
        key: 'cart.chargeMethod.perUnit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Unit',
        label: 'Per Unit Charge Method',
    },
    {
        key: 'cart.chargeMethod.perApplicant',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Applicant',
        label: 'Per Applicant Charge Method',
    },
    {
        key: 'cart.chargeMethod.perOccurrence',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Occurrence',
        label: 'Per Occurrence Charge Method',
    },
    {
        key: 'cart.chargeMethod.perRentableItem',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Rentable Item',
        label: 'Per Rentable Item Charge Method',
    },
    {
        key: 'cart.chargeMethod.perLeaseHolder',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Lease Holder',
        label: 'Per Lease Holder Charge Method',
    },
    {
        key: 'cart.chargeMethod.perResident',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Resident',
        label: 'Per Resident Charge Method',
    },
    {
        key: 'cart.chargeMethod.perVehicle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Vehicle',
        label: 'Per Vehicle Charge Method',
    },
    {
        key: 'cart.chargeMethod.perPet',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Per Pet',
        label: 'Per Pet Charge Method',
    },
    {
        key: 'cart.requirement.mandatory',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Mandatory',
        label: 'Mandatory Charge Requirement',
    },
    {
        key: 'cart.requirement.required',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Required',
        label: 'Required Charge Requirement',
    },
    {
        key: 'cart.requirement.optional',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Optional',
        label: 'Optional Charge Requirement',
    },
    {
        key: 'cart.requirement.situational',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Situational',
        label: 'Situational Charge Requirement',
    },
    // Offers Page
    {
        key: 'offers.yourQuotes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your Quotes',
        label: 'Your Quotes Heading',
    },
    {
        key: 'offers.yourWaitlistOffers',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your Waitlist Offers',
        label: 'Your Waitlist Offers Heading',
    },
    {
        key: 'offers.noQuotes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No quotes or waitlist offers available at this time.',
        label: 'No Quotes Message',
    },
    {
        key: 'offers.selectALeaseTerm',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a Lease Term',
        label: 'Select a Lease Term Label',
    },
    {
        key: 'offers.leaseTerms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Lease Terms',
        label: 'Lease Terms Heading',
    },
    {
        key: 'offers.monthlyRent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly Rent',
        label: 'Monthly Rent Column Header',
    },
    {
        key: 'offers.rent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Rent',
        label: 'Rent Column Header (Compact)',
    },
    {
        key: 'offers.monthlyTaxes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly Taxes',
        label: 'Monthly Taxes Column Header',
    },
    {
        key: 'offers.taxes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Taxes',
        label: 'Taxes Column Header (Compact)',
    },
    {
        key: 'offers.monthlyTotal',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly Total',
        label: 'Monthly Total Column Header',
    },
    {
        key: 'offers.total',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Total',
        label: 'Total Column Header (Compact)',
    },
    {
        key: 'offers.quoteNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Quote Number',
        label: 'Quote Number Label',
    },
    {
        key: 'offers.moveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-In Date',
        label: 'Move-In Date Label (Offers)',
    },
    {
        key: 'offers.layout',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Layout',
        label: 'Layout Label (Offers)',
    },
    {
        key: 'offers.deposit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Deposit',
        label: 'Deposit Label (Offers)',
    },
    {
        key: 'offers.sqFt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sq. Ft.',
        label: 'Square Feet Label (Offers)',
    },
    {
        key: 'offers.quoteExpires',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Quote Expires',
        label: 'Quote Expires Label',
    },
    {
        key: 'offers.useThisQuote',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Use this Quote',
        label: 'Use This Quote Button',
    },
    {
        key: 'offers.unitNoLongerAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit No Longer Available',
        label: 'Unit No Longer Available Badge',
    },
    {
        key: 'offers.quoteExpiredOn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Quote expired {{date}}',
        label: 'Quote Expired Message',
        params: ['date'],
    },
    // Application Status
    {
        key: 'appStatus.moveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-in Date',
        label: 'Move-in Date Label (Status Card)',
    },
    {
        key: 'appStatus.unit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit',
        label: 'Unit Label (Status Card)',
    },
    {
        key: 'appStatus.child',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Child',
        label: 'Child Occupant Type',
    },
    {
        key: 'appStatus.adult',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Adult',
        label: 'Adult Occupant Type',
    },
    {
        key: 'appStatus.yrs',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yrs',
        label: 'Years Abbreviation',
    },
    {
        key: 'appStatus.mos',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Mos',
        label: 'Months Abbreviation',
    },
    {
        key: 'appStatus.days',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Days',
        label: 'Days Abbreviation',
    },
    // Application status card status text & descriptions (from getApplicationStatusCardText)
    {
        key: 'appStatus.statusCancelled',
        defaultValue: 'Cancelled',
        category: SystemTranslationCategory.Common,
        label: 'Status: Cancelled',
    },
    {
        key: 'appStatus.descCancelled',
        defaultValue: 'This has been cancelled.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Cancelled',
    },
    {
        key: 'appStatus.statusDenied',
        defaultValue: 'Denied',
        category: SystemTranslationCategory.Common,
        label: 'Status: Denied',
    },
    {
        key: 'appStatus.descDenied',
        defaultValue: 'This has been denied. Please contact the property for more information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Denied',
    },
    {
        key: 'appStatus.statusExpired',
        defaultValue: 'Expired',
        category: SystemTranslationCategory.Common,
        label: 'Status: Expired',
    },
    {
        key: 'appStatus.descExpired',
        defaultValue: 'This has expired.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Expired',
    },
    {
        key: 'appStatus.statusArchived',
        defaultValue: 'Archived',
        category: SystemTranslationCategory.Common,
        label: 'Status: Archived',
    },
    {
        key: 'appStatus.descArchived',
        defaultValue: 'This has been archived.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Archived',
    },
    {
        key: 'appStatus.statusApplicationStarted',
        defaultValue: 'Application Started',
        category: SystemTranslationCategory.Common,
        label: 'Status: Application Started',
    },
    {
        key: 'appStatus.descWaitingForOthers',
        defaultValue: 'We are now waiting for others to complete their information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Waiting for others',
    },
    {
        key: 'appStatus.descApplicationStarted',
        defaultValue: 'Your application has been started but not completed.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Application started',
    },
    {
        key: 'appStatus.resumeApplication',
        defaultValue: 'Resume Application',
        category: SystemTranslationCategory.Common,
        label: 'Resume Application button',
    },
    {
        key: 'appStatus.statusApplicationPartiallyCompleted',
        defaultValue: 'Application Partially Completed',
        category: SystemTranslationCategory.Common,
        label: 'Status: Application Partially Completed',
    },
    {
        key: 'appStatus.descApplicationPartiallyComplete',
        defaultValue: 'Your application is partially complete but still missing some required information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Application partially complete',
    },
    {
        key: 'appStatus.statusApplicationApproved',
        defaultValue: 'Application Approved',
        category: SystemTranslationCategory.Common,
        label: 'Status: Application Approved',
    },
    {
        key: 'appStatus.descApplicationApproved',
        defaultValue: 'Your application has been approved. Waiting for property approval.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Application approved',
    },
    {
        key: 'appStatus.statusApplicationCompleted',
        defaultValue: 'Application Completed',
        category: SystemTranslationCategory.Common,
        label: 'Status: Application Completed',
    },
    {
        key: 'appStatus.descApplicationComplete',
        defaultValue: 'Your application is complete. Waiting for others to complete their information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Application complete',
    },
    {
        key: 'appStatus.statusConditionallyApproved',
        defaultValue: 'Application Conditionally Approved',
        category: SystemTranslationCategory.Common,
        label: 'Status: Conditionally Approved',
    },
    {
        key: 'appStatus.selectConditions',
        defaultValue: 'Select Conditions',
        category: SystemTranslationCategory.Common,
        label: 'Select Conditions button',
    },
    {
        key: 'appStatus.descConditionallyApproved',
        defaultValue: 'Your application has been approved with conditions. View and select your condition options to continue with the application process.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Conditionally approved',
    },
    {
        key: 'appStatus.statusLeaseReadyToSign',
        defaultValue: 'Lease Ready to Sign',
        category: SystemTranslationCategory.Common,
        label: 'Status: Lease Ready to Sign',
    },
    {
        key: 'appStatus.descLeaseReadyToSign',
        defaultValue: 'Your application is fully approved and your lease documents are ready to sign.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Lease ready to sign',
    },
    {
        key: 'appStatus.statusLeasePartiallyCompleted',
        defaultValue: 'Lease Partially Completed',
        category: SystemTranslationCategory.Common,
        label: 'Status: Lease Partially Completed',
    },
    {
        key: 'appStatus.descLeasePartiallyCompleted',
        defaultValue: 'Your lease is complete and we are now waiting for others to finalize their information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Lease partially completed',
    },
    {
        key: 'appStatus.statusLeaseCompleted',
        defaultValue: 'Lease Completed',
        category: SystemTranslationCategory.Common,
        label: 'Status: Lease Completed',
    },
    {
        key: 'appStatus.descLeaseCompleted',
        defaultValue: 'Your lease has been signed. We are waiting for others to complete their signing portions.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Lease completed',
    },
    {
        key: 'appStatus.statusLeaseApproved',
        defaultValue: 'Lease Approved',
        category: SystemTranslationCategory.Common,
        label: 'Status: Lease Approved',
    },
    {
        key: 'appStatus.descLeaseApproved',
        defaultValue: 'All parties have signed your lease. Please contact the property for move-in details.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Lease approved',
    },
    {
        key: 'appStatus.statusApplicationSubmitted',
        defaultValue: 'Application Submitted',
        category: SystemTranslationCategory.Common,
        label: 'Status: Application Submitted',
    },
    {
        key: 'appStatus.descApplicationSubmitted',
        defaultValue: 'Your application has been submitted. Waiting for others to complete their information.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Application submitted',
    },
    {
        key: 'appStatus.statusSubmissionFailed',
        defaultValue: 'Submission Failed',
        category: SystemTranslationCategory.Common,
        label: 'Status: Submission Failed',
    },
    {
        key: 'appStatus.checkingCompletion',
        defaultValue: 'Checking completion status…',
        category: SystemTranslationCategory.Common,
        label: 'Checking application completion',
    },
    {
        key: 'appStatus.checkingCompletionHint',
        defaultValue: 'This may take a few moments.',
        category: SystemTranslationCategory.Common,
        label: 'Application completion checking hint',
    },
    {
        key: 'appStatus.completionFailed',
        defaultValue: 'We could not complete your application.',
        category: SystemTranslationCategory.Common,
        label: 'Application completion failure',
    },
    {
        key: 'appStatus.statusCheckUnavailable',
        defaultValue: 'Unable to confirm application status',
        category: SystemTranslationCategory.Common,
        label: 'Application status unavailable',
    },
    {
        key: 'appStatus.statusCheckFailed',
        defaultValue: 'We could not check your application status. It may still be processing.',
        category: SystemTranslationCategory.Common,
        label: 'Application status check failed',
    },
    {
        key: 'appStatus.statusCheckDelayed',
        defaultValue: 'Checking is taking longer than expected. Your application may still be processing.',
        category: SystemTranslationCategory.Common,
        label: 'Application status check delayed',
    },
    {
        key: 'appStatus.retryStatusCheck',
        defaultValue: 'Retry status check',
        category: SystemTranslationCategory.Common,
        label: 'Retry application status check',
    },
    {
        key: 'appStatus.completionFailureHelp',
        defaultValue: 'Please contact the property manager for help completing your application.',
        category: SystemTranslationCategory.Common,
        label: 'Application completion failure help',
    },
    {
        key: 'appStatus.applicationCompletionFailure',
        defaultValue: 'Your application could not be finalized. Please contact the property manager for help.',
        category: SystemTranslationCategory.Common,
        label: 'Application finalization failure',
    },
    {
        key: 'appStatus.specialOffersFailure',
        defaultValue: 'Your application was submitted, but its special offers could not be finalized. Please contact the property manager before submitting again.',
        category: SystemTranslationCategory.Common,
        label: 'Application special offers failure',
    },
    {
        key: 'appStatus.descSubmissionFailed',
        defaultValue: 'We encountered an issue submitting your application. Our team has been notified and will assist you shortly. Please contact support if you need immediate help.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Submission failed',
    },
    {
        key: 'appStatus.statusUnknown',
        defaultValue: 'Unknown Status',
        category: SystemTranslationCategory.Common,
        label: 'Status: Unknown',
    },
    {
        key: 'appStatus.descUnknown',
        defaultValue: 'Status not recognized.',
        category: SystemTranslationCategory.Common,
        label: 'Description: Unknown status',
    },
    // Waitlist
    {
        key: 'waitlist.leaveWaitlist',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Leave Waitlist',
        label: 'Leave Waitlist Button',
    },
    {
        key: 'waitlist.joinWaitlist',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Join Waitlist',
        label: 'Join Waitlist Button',
    },
    {
        key: 'waitlist.accept',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Accept',
        label: 'Accept Waitlist Offer Button',
    },
    {
        key: 'waitlist.decline',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Decline',
        label: 'Decline Waitlist Offer Button',
    },
    {
        key: 'waitlist.leavingWaitlist',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Leaving Waitlist...',
        label: 'Leaving Waitlist Loading State',
    },
    {
        key: 'waitlist.leavingWaitlists',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Leaving Waitlists...',
        label: 'Leaving Waitlists (plural) Loading State',
    },
    {
        key: 'waitlist.leaveAllWaitlists',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Leave All Waitlists',
        label: 'Leave All Waitlists Button',
    },
    {
        key: 'waitlist.stayOnWaitlist',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Stay on Waitlist',
        label: 'Stay on Waitlist Button',
    },
    {
        key: 'waitlist.stayOnWaitlists',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Stay on Waitlists',
        label: 'Stay on Waitlists (plural) Button',
    },
    {
        key: 'waitlist.unitAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unit Available for Your Waitlisted Floor Plan',
        label: 'Unit Available (singular) Dialog Title',
    },
    {
        key: 'waitlist.unitsAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Units Available for Your Waitlisted Floor Plans',
        label: 'Units Available (plural) Dialog Title',
    },
    {
        key: 'waitlist.availableSingleFloorPlanMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: "Great news! Units are now available for the floor plan for which you are on the waitlist. To choose an available unit, you'll need to first leave {{waitlistScope}}.",
        label: 'Single Waitlisted Floor Plan Available Message',
        params: ['waitlistScope'],
    },
    {
        key: 'waitlist.availableMultipleFloorPlansMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: "Great news! Units are now available for the following floor plans for which you are on the waitlist. To choose an available unit, you'll need to first leave {{waitlistScope}}.",
        label: 'Multiple Waitlisted Floor Plans Available Message',
        params: ['waitlistScope'],
    },
    {
        key: 'waitlist.thisWaitlist',
        category: SystemTranslationCategory.Common,
        defaultValue: 'this waitlist',
        label: 'Current Waitlist Reference',
    },
    {
        key: 'waitlist.allWaitlists',
        category: SystemTranslationCategory.Common,
        defaultValue: 'all waitlists',
        label: 'All Waitlists Reference',
    },
    {
        key: 'waitlist.bedroomsBathrooms',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{bedrooms}} Bed / {{bathrooms}} Bath',
        label: 'Waitlist Floor Plan Bedroom Bathroom Summary',
        params: ['bedrooms', 'bathrooms'],
    },
    {
        key: 'waitlist.addedNotification',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Successfully added to waitlist for {{name}} floor plan.',
        label: 'Added to Waitlist Notification',
        params: ['name'],
    },
    {
        key: 'waitlist.removedNotification',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Successfully removed from waitlist for {{name}} floor plan.',
        label: 'Removed from Waitlist Notification',
        params: ['name'],
    },
    {
        key: 'waitlist.moveInDate',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Move-in Date',
        label: 'Move-in Date (Waitlist Card)',
    },
    {
        key: 'waitlist.floorPlan',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floor plan',
        label: 'Floor Plan Label (Waitlist Card)',
    },
    {
        key: 'waitlist.offerValidUntil',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your offer is valid until {{reserveUntil}}. Take action before your unit is released to the next applicant on the waitlist.',
        label: 'Offer Valid Until Message',
        params: ['reserveUntil'],
    },
    // Misc / Error (additional)
    {
        key: 'error.pageNotFound',
        category: SystemTranslationCategory.Common,
        defaultValue: '404 - Not Found',
        label: '404 Page Title',
    },
    {
        key: 'error.pageNotFoundMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'The page you are looking for does not exist.',
        label: '404 Page Message',
    },
    {
        key: 'error.fetchingApplications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error fetching applicant applications',
        label: 'Error Fetching Applications',
    },
    {
        key: 'error.initializingApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error while initializing application.',
        label: 'Error Initializing Application',
    },
    {
        key: 'common.loadingApplications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading applications...',
        label: 'Loading Applications Loader',
    },
    {
        key: 'common.initializingApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Initializing new application...',
        label: 'Initializing New Application Loader',
    },
    {
        key: 'common.dontHaveField',
        category: SystemTranslationCategory.Common,
        defaultValue: "I don't have a {{label}}.",
        label: 'Field Absence Checkbox Label',
        params: ['label'],
    },
    {
        key: 'common.homebodyInsuranceEnrollment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Homebody Insurance Enrollment',
        label: 'Homebody Insurance Enrollment — page title',
    },
    {
        key: 'common.homebodyUnifiedWorkflowNotConfigured',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Homebody unified workflow is not configured. Set HOMEBODY_UNIFIED_WORKFLOW_DIST_URL in your environment.',
        label: 'Homebody Unified Workflow — missing dist URL configuration',
    },
    {
        key: 'common.homebodyUnifiedWorkflowLoadFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to load Homebody unified workflow.',
        label: 'Homebody Unified Workflow — script load failed',
    },
    {
        key: 'common.homebodyUnifiedWorkflowNotAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Insurance enrollment is not available for this application yet.',
        label: 'Homebody Unified Workflow — enrollment not available',
    },
    {
        key: 'common.cancel',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Cancel',
        label: 'Cancel Button',
    },
    {
        key: 'common.add',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add',
        label: 'Add Button',
    },
    {
        key: 'common.save',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Save',
        label: 'Save Button',
    },
    {
        key: 'common.removeItem',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Remove Item',
        label: 'Remove Item Accessibility Label',
    },
    {
        key: 'common.free',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Free',
        label: 'Free Price Label',
    },
    {
        key: 'common.rented',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Rented',
        label: 'Rented Label',
    },
    {
        key: 'common.included',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Included',
        label: 'Included Label',
    },
    {
        key: 'common.services',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Services',
        label: 'Services Heading',
    },
    {
        key: 'common.rentableItems',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Rentable Items',
        label: 'Rentable Items Heading',
    },
    {
        key: 'common.viewPricingOptions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View Pricing Options',
        label: 'View Pricing Options Button',
    },
    {
        key: 'common.editRentableItem',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Edit Rentable Item',
        label: 'Edit Rentable Item Modal Title',
    },
    {
        key: 'common.removeOptionConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you want to remove this option?',
        label: 'Remove Option Confirmation Text',
    },
    {
        key: 'common.removeSpecialConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you want to remove this special?',
        label: 'Remove Special Confirmation Text',
    },
    {
        key: 'common.close',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Close',
        label: 'Close Button',
    },
    {
        key: 'common.delete',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Delete',
        label: 'Delete Button',
    },
    {
        key: 'common.removeAlternateId',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Remove {{name}}',
        label: 'Remove Alternate ID Button',
        params: ['name'],
    },
    {
        key: 'common.deleting',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Deleting...',
        label: 'Deleting Loading State',
    },
    {
        key: 'common.removePetConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you wish to remove this pet?',
        label: 'Remove Pet Confirmation Text',
    },
    {
        key: 'common.petNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pet {{number}}',
        label: 'Pet Number Label',
        params: ['number'],
    },
    {
        key: 'common.removePet',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Remove pet',
        label: 'Remove Pet Accessibility Label',
    },
    {
        key: 'common.petPolicy',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pet Policy',
        label: 'Pet Policy Button',
    },
    {
        key: 'common.unableToRemovePets',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to remove pets.',
        label: 'Unable to Remove Pets Error',
    },
    {
        key: 'common.pounds',
        category: SystemTranslationCategory.Common,
        defaultValue: 'lbs.',
        label: 'Pet Weight Unit',
    },
    {
        key: 'common.unitSquareFeet',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Square Feet',
        label: 'Square Feet Unit of Measure',
    },
    {
        key: 'common.unitSquareMeters',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Square Meters',
        label: 'Square Meters Unit of Measure',
    },
    {
        key: 'common.unitPounds',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pounds (lbs)',
        label: 'Pounds Unit of Measure',
    },
    {
        key: 'common.unitKilograms',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Kilograms (kg)',
        label: 'Kilograms Unit of Measure',
    },
    {
        key: 'common.unitMiles',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Miles (mi)',
        label: 'Miles Unit of Measure',
    },
    {
        key: 'common.unitKilometers',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Kilometers (km)',
        label: 'Kilometers Unit of Measure',
    },
    {
        key: 'common.years',
        category: SystemTranslationCategory.Common,
        defaultValue: 'yrs',
        label: 'Pet Age Unit',
    },
    {
        key: 'common.perMonth',
        category: SystemTranslationCategory.Common,
        defaultValue: 'per month',
        label: 'Per Month',
    },
    {
        key: 'common.perDay',
        category: SystemTranslationCategory.Common,
        defaultValue: 'per day',
        label: 'Per Day',
    },
    {
        key: 'common.perWeek',
        category: SystemTranslationCategory.Common,
        defaultValue: 'per week',
        label: 'Per Week',
    },
    {
        key: 'common.perNight',
        category: SystemTranslationCategory.Common,
        defaultValue: 'per night',
        label: 'Per Night',
    },
    {
        key: 'floorPlan.noUnitsAvailableText',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No Units Available',
        label: 'No Units Available Text',
    },
    {
        key: 'floorPlan.onlyUnitAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Only {{count}} Unit Available!',
        label: 'Only One Unit Available Text',
        params: ['count'],
    },
    {
        key: 'floorPlan.unitsAvailableText',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} Units Available',
        label: 'Units Available Text',
        params: ['count'],
    },
    {
        key: 'floorPlan.noSpacesAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No spaces available',
        label: 'No Spaces Available Message',
    },
    {
        key: 'floorPlan.viewOnMap',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View on Map',
        label: 'View on Map Link',
    },
    {
        key: 'floorPlan.imageAlt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Floor plan image',
        label: 'Floor Plan Image Alt Text',
    },
    {
        key: 'common.deleteConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you wish to delete?',
        label: 'Delete Confirmation Text',
    },
    {
        key: 'common.deleteIncomeTypeConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you wish to delete this income type?',
        label: 'Delete Income Type Confirmation Text',
    },
    {
        key: 'common.yes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yes',
        label: 'Yes Option',
    },
    {
        key: 'common.no',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No',
        label: 'No Option',
    },
    {
        key: 'common.male',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Male',
        label: 'Male Option',
    },
    {
        key: 'common.female',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Female',
        label: 'Female Option',
    },
    {
        key: 'common.owner',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Owner',
        label: 'Owner Option',
    },
    {
        key: 'common.renter',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Renter',
        label: 'Renter Option',
    },
    {
        key: 'common.pleaseUploadDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please Upload documents',
        label: 'Please Upload Documents Prompt',
    },
    {
        key: 'common.uploadDocuments',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload Documents',
        label: 'Upload Documents Button',
    },
    {
        key: 'common.allowedFileTypes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Allowed:',
        label: 'Allowed File Types Label',
    },
    {
        key: 'common.viewPetPolicy',
        category: SystemTranslationCategory.Common,
        defaultValue: 'View Pet Policy',
        label: 'View Pet Policy Link',
    },
    {
        key: 'common.myPetIsAssistanceAnimal',
        category: SystemTranslationCategory.Common,
        defaultValue: 'My pet is an assistance animal',
        label: 'Pet Assistance Animal Checkbox',
    },
    {
        key: 'common.addIncome',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add Income',
        label: 'Add Income Button',
    },
    {
        key: 'common.intervalWeekly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Weekly',
        label: 'Weekly Interval Label',
    },
    {
        key: 'common.intervalBiWeekly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Bi-Weekly',
        label: 'Bi-Weekly Interval Label',
    },
    {
        key: 'common.intervalSemiMonthly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Semi-Monthly',
        label: 'Semi-Monthly Interval Label',
    },
    {
        key: 'common.intervalMonthly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Monthly',
        label: 'Monthly Interval Label',
    },
    {
        key: 'common.intervalAnnual',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Annual',
        label: 'Annual Interval Label',
    },
    {
        key: 'common.intervalHourly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Hourly',
        label: 'Hourly Interval Label',
    },
    {
        key: 'common.intervalYearly',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yearly',
        label: 'Yearly Interval Label',
    },
    {
        key: 'common.grossIncomeByInterval',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{interval}} Gross Income',
        label: 'Gross Income Label by Interval',
        params: ['interval'],
    },
    {
        key: 'common.salaryByInterval',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{interval}} Salary',
        label: 'Salary Label by Interval',
        params: ['interval'],
    },
    {
        key: 'common.expenseAmountByInterval',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{interval}} Expense Amount',
        label: 'Expense Amount Label by Interval',
        params: ['interval'],
    },
    {
        key: 'common.incomeTypeLabel',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Income Type',
        label: 'Income Type Label',
    },
    {
        key: 'common.selectIncomeType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select income type',
        label: 'Select Income Type Placeholder',
    },
    {
        key: 'common.addExpense',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add Expense',
        label: 'Add Expense Button',
    },
    {
        key: 'common.expenseType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Expense Type',
        label: 'Expense Type Label',
    },
    {
        key: 'common.selectExpenseType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select expense type',
        label: 'Select Expense Type Placeholder',
    },
    {
        key: 'common.addAsset',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Add Asset',
        label: 'Add Asset Button',
    },
    {
        key: 'common.removeAllAssetsConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Selecting “No” will remove all asset details you have entered. These assets will be deleted when you save. Do you want to continue?',
        label: 'Remove All Assets Confirmation',
    },
    {
        key: 'common.removeAllAssets',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Yes, remove assets',
        label: 'Remove All Assets Confirmation Button',
    },
    {
        key: 'common.assetType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Asset Type',
        label: 'Asset Type Label',
    },
    {
        key: 'common.selectAssetType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select asset type',
        label: 'Select Asset Type Placeholder',
    },
    {
        key: 'common.pleaseCompleteAllRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please fill out all required information below.',
        label: 'Please Complete All Required Notice',
    },
    {
        key: 'common.occupancyLimitsNote',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Actual occupancy limits may vary by unit',
        label: 'Occupancy Limits Note',
    },
    {
        key: 'common.creatingCoApplicant',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Creating co-applicant...',
        label: 'Creating Co-Applicant Loader',
    },
    {
        key: 'common.coApplicantApplicationTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Co-Applicant Application',
        label: 'Co-Applicant Application Modal Title',
    },
    {
        key: 'common.creatingGuarantor',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Creating guarantor...',
        label: 'Creating Guarantor Loader',
    },
    {
        key: 'common.guarantorApplicationTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Application',
        label: 'Guarantor Application Modal Title',
    },
    {
        key: 'common.uploadingFile',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Uploading file...',
        label: 'Uploading File Loader',
    },
    {
        key: 'common.deletingFile',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Deleting file...',
        label: 'Deleting File Loader',
    },
    {
        key: 'common.processingPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Processing Payment',
        label: 'Processing Payment Loader',
    },
    {
        key: 'common.loadingInstruction',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading Instruction',
        label: 'Loading Instruction Loader',
    },
    {
        key: 'common.decliningScreeningConditions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Declining Screening Conditions',
        label: 'Declining Screening Conditions Loader',
    },
    {
        key: 'common.addingGuarantor',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Adding Guarantor',
        label: 'Adding Guarantor Loader',
    },
    {
        key: 'common.applyingScreeningConditions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Applying Screening Conditions',
        label: 'Applying Screening Conditions Loader',
    },
    {
        key: 'common.gettingPaymentAccounts',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Getting payment accounts',
        label: 'Getting Payment Accounts Loader',
    },
    {
        key: 'common.addingPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Adding Payment',
        label: 'Adding Payment Loader',
    },
    {
        key: 'common.guarantorFirstName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor First Name',
        label: 'Guarantor First Name Label',
    },
    {
        key: 'common.guarantorLastName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Last Name',
        label: 'Guarantor Last Name Label',
    },
    {
        key: 'common.guarantorDateOfBirth',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Date of Birth',
        label: 'Guarantor Date of Birth Label',
    },
    {
        key: 'common.guarantorPhone',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Phone',
        label: 'Guarantor Phone Label',
    },
    {
        key: 'common.guarantorEmail',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Email',
        label: 'Guarantor Email Label',
    },
    {
        key: 'common.guarantorRelationship',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Guarantor Relationship',
        label: 'Guarantor Relationship Label',
    },
    {
        key: 'common.unableToRenderUnits',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to render units.',
        label: 'Unable To Render Units Message',
    },
    {
        key: 'common.unableToRenderField',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to render this field',
        label: 'Unable To Render Field Message',
    },
    {
        key: 'common.loadingRoommateInterests',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading roommate interests...',
        label: 'Loading Roommate Interests Message',
    },
    {
        key: 'common.unableToLoadRoommateInterests',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to load roommate interests',
        label: 'Unable To Load Roommate Interests Message',
    },
    {
        key: 'common.noRoommateInterestQuestionsAvailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'There are no roommate interest questions available.',
        label: 'No Roommate Interest Questions Available Message',
    },
    {
        key: 'common.roommateInvitationPending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Pending',
        label: 'Roommate Invitation Pending Status',
    },
    {
        key: 'common.roommateInvitationName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Name',
        label: 'Roommate Invitation Name Header',
    },
    {
        key: 'common.roommateInviteQuestion',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Would you like to invite roommates to join your group?',
        label: 'Roommate Invite Question',
    },
    {
        key: 'common.roommateFirstName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'First Name',
        label: 'Roommate First Name Field',
    },
    {
        key: 'common.roommateLastName',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Last Name',
        label: 'Roommate Last Name Field',
    },
    {
        key: 'common.roommateEmail',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Email',
        label: 'Roommate Email Field',
    },
    {
        key: 'common.roommatePrimaryPhone',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Primary Phone',
        label: 'Roommate Primary Phone Field',
    },
    {
        key: 'common.roommateInvitationEmail',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Email',
        label: 'Roommate Invitation Email Header',
    },
    {
        key: 'common.roommateInvitationSentHeader',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Invitation Sent',
        label: 'Roommate Invitation Sent Header',
    },
    {
        key: 'common.roommateInvitationStatusHeader',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Status',
        label: 'Roommate Invitation Status Header',
    },
    {
        key: 'common.roommateInvitationSend',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Send Invitation',
        label: 'Send Roommate Invitation Button',
    },
    {
        key: 'common.roommateInvitationRequiresFloorplanAndLeaseTerm',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select Lease Term and Floorplan before sending roommate invitation!',
        label: 'Roommate Invitation Floorplan and Lease Term Requirement',
    },
    {
        key: 'common.roommateInvitationSending',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sending',
        label: 'Sending Roommate Invitation State',
    },
    {
        key: 'common.roommateInvitationSent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Sent',
        label: 'Roommate Invitation Sent Status',
    },
    {
        key: 'common.roommateInvitationError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error',
        label: 'Roommate Invitation Error Status',
    },
    {
        key: 'common.roommateInvitationDeliveryFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate details saved, but the invitation could not be sent',
        label: 'Roommate Invitation Delivery Failure',
    },
    {
        key: 'common.roommateInvitationSentStatusSaveFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate invitation was sent, but its status could not be saved',
        label: 'Roommate Invitation Status Save Failure',
    },
    {
        key: 'common.roommateInvitationStatusRetryFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to save the invitation status. Please try again.',
        label: 'Roommate Invitation Status Retry Failure',
    },
    {
        key: 'common.roommateGroupDeleteConfirmation',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Do you want to cancel your roommate group? This will delete the roommate grouping.',
        label: 'Roommate Group Delete Confirmation',
    },
    {
        key: 'common.roommateGroupDeleteReason',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate group deleted by the group creator from Leasing Journey.',
        label: 'Roommate Group Delete Audit Reason',
    },
    {
        key: 'common.roommateGroupDeleteFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to delete the roommate group. Please try again.',
        label: 'Roommate Group Delete Failure',
    },
    {
        key: 'common.retry',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Retry',
        label: 'Retry Button',
    },
    {
        key: 'common.roommateInvitationsReceived',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Invitations Received',
        label: 'Roommate Invitations Received Heading',
    },
    {
        key: 'common.roommateInvitationInviteFrom',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Invite From',
        label: 'Roommate Invitation Inviter Header',
    },
    {
        key: 'common.roommateInvitationMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Message',
        label: 'Roommate Invitation Message Header',
    },
    {
        key: 'common.roommateInvitationAction',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Action',
        label: 'Roommate Invitation Action Header',
    },
    {
        key: 'common.roommateInvitationAccept',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Accept',
        label: 'Roommate Invitation Accept Button',
    },
    {
        key: 'common.roommateInvitationReject',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Reject',
        label: 'Roommate Invitation Reject Button',
    },
    {
        key: 'common.roommateInvitationGroup',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate group',
        label: 'Roommate Invitation Group Fallback',
    },
    {
        key: 'common.roommateInvitationReceivedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You have been invited to be a roommate.',
        label: 'Roommate Invitation Received Message',
    },
    {
        key: 'common.roommateInvitationAccepted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate invitation accepted.',
        label: 'Roommate Invitation Accepted Message',
    },
    {
        key: 'common.roommateInvitationRejected',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate invitation rejected.',
        label: 'Roommate Invitation Rejected Message',
    },
    {
        key: 'common.roommateInvitationAcceptFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to accept the roommate invitation. Please try again.',
        label: 'Roommate Invitation Accept Failure',
    },
    {
        key: 'common.roommateInvitationRejectFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to reject the roommate invitation. Please try again.',
        label: 'Roommate Invitation Reject Failure',
    },
    {
        key: 'common.roommateApplicationContextUnavailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to save roommate details: application context is unavailable',
        label: 'Roommate Application Context Unavailable',
    },
    {
        key: 'common.roommateDetailsRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Enter roommate details before saving',
        label: 'Roommate Details Required',
    },
    {
        key: 'common.roommateStudentSetupFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate details saved, but Student setup failed',
        label: 'Roommate Student Setup Failure',
    },
    {
        key: 'common.roommateResponseUpdateFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'response update failed',
        label: 'Roommate Response Update Failure',
    },
    {
        key: 'common.roommateStudentStatusSaveFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Roommate details saved, but Student setup status could not be saved',
        label: 'Roommate Student Status Save Failure',
    },
    {
        key: 'common.roommateEmailUnavailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'email is unavailable',
        label: 'Roommate Email Unavailable',
    },
    {
        key: 'common.roommateSaveFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to save roommate details',
        label: 'Roommate Save Failure',
    },
    {
        key: 'common.tryAgain',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Try Again',
        label: 'Try Again Button',
    },
    {
        key: 'common.noNotifications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You have no notifications.',
        label: 'No Notifications Message',
    },
    {
        key: 'common.notifications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Notifications',
        label: 'Notifications Heading',
    },
    {
        key: 'common.new',
        category: SystemTranslationCategory.Common,
        defaultValue: 'New',
        label: 'New Section Label',
    },
    {
        key: 'common.clearAll',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Clear All',
        label: 'Clear All Action',
    },
    {
        key: 'common.allCaughtUp',
        category: SystemTranslationCategory.Common,
        defaultValue: "You're all caught up!",
        label: 'All Caught Up Message (Notifications)',
    },
    {
        key: 'common.pastNotifications',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Past Notifications',
        label: 'Past Notifications Heading',
    },
    {
        key: 'common.somethingWentWrong',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Something went wrong.',
        label: 'Something Went Wrong Message',
    },
    {
        key: 'common.failedToLoadCharges',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Failed to load charges.',
        label: 'Failed to Load Charges Message',
    },
    {
        key: 'common.failedToLoadChargesDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We could not retrieve the scheduled charges. Please try again.',
        label: 'Failed to Load Charges Description',
    },
    {
        key: 'common.pageNotFound',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Page not found.',
        label: 'Page Not Found Message',
    },
    {
        key: 'common.conditionallyApproved',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Conditionally Approved',
        label: 'Conditionally Approved Heading',
    },
    {
        key: 'common.screeningApprovedDescription',
        category: SystemTranslationCategory.Common,
        defaultValue: 'We have carefully considered your application and have approved it with one or more conditions.',
        label: 'Screening Approved Description',
    },
    {
        key: 'common.screeningSelectOption',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select an option below to continue the application approval process:',
        label: 'Screening Select Option Prompt',
    },
    {
        key: 'common.screeningChooseOptions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Choose {{quantity}} of these options',
        label: 'Screening Condition Selection Quantity',
        params: ['quantity'],
    },
    {
        key: 'common.screeningAllOptions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'All',
        label: 'Screening Condition All Options Quantity',
    },
    {
        key: 'common.screeningConditionAnd',
        category: SystemTranslationCategory.Common,
        defaultValue: 'AND',
        label: 'Screening Condition And Operator',
    },
    {
        key: 'common.screeningConditionOr',
        category: SystemTranslationCategory.Common,
        defaultValue: 'OR',
        label: 'Screening Condition Or Operator',
    },
    {
        key: 'common.screeningConditionHeadingWithOperator',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{operator}} {{heading}}',
        label: 'Screening Condition Heading With Operator',
        params: ['operator', 'heading'],
    },
    {
        key: 'common.screeningInvalidSelection',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please choose the correct number of options.',
        label: 'Screening Condition Invalid Selection Error',
    },
    {
        key: 'common.screeningRequiredGuarantorFields',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please fill out all required fields.',
        label: 'Screening Condition Required Guarantor Fields Error',
    },
    {
        key: 'common.screeningOptionsSaved',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your selected options have been saved.',
        label: 'Screening Condition Options Saved Confirmation',
    },
    {
        key: 'common.screeningOptionsSavedGuarantor',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your selected options have been saved and an email has been sent to {{email}}.',
        label: 'Screening Condition Guarantor Invitation Confirmation',
        params: ['email'],
    },
    {
        key: 'common.screeningOptionsSavedPayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Your selected options have been saved and your payment has been processed.',
        label: 'Screening Condition Payment Confirmation',
    },
    {
        key: 'common.screeningConditionSelected',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Condition Selected: {{conditions}}',
        label: 'Screening Condition Selected Summary',
        params: ['conditions'],
    },
    {
        key: 'common.screeningConditionsSelected',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Conditions Selected: {{conditions}}',
        label: 'Screening Conditions Selected Summary',
        params: ['conditions'],
    },
    {
        key: 'common.depositAlternativeConditionPricing',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{chargeAmount}} per month and a one-time {{diEnrollmentFee}} enrollment fee',
        label: 'Deposit Alternative Condition Monthly And Enrollment Pricing',
        params: ['chargeAmount', 'diEnrollmentFee'],
    },
    {
        key: 'common.saving',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Saving...',
        label: 'Saving Loader',
    },
    {
        key: 'builderLeasePackets.loading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading properties and lease packets…',
        label: 'Builder Lease Packet Properties Loading Status',
    },
    {
        key: 'builderLeasePackets.saving',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Saving lease packet preferences…',
        label: 'Builder Lease Packet Preferences Saving Status',
    },
    {
        key: 'builderLeasePackets.propertyCount',
        category: SystemTranslationCategory.Common,
        defaultValue: '{%p, count, =0{# properties} =1{# property} other{# properties}}. This may take a moment.',
        label: 'Builder Lease Packet Operation Property Count',
        params: ['count'],
    },
    {
        key: 'builderLeasePackets.savingButton',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Saving packets…',
        label: 'Builder Lease Packet Saving Button',
    },
    {
        key: 'common.discard',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Discard',
        label: 'Discard Button',
    },
    {
        key: 'common.selectSpecialOptions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select {{count}} of the following options:',
        label: 'Special Options Selection Prompt',
        params: ['count'],
    },
    {
        key: 'common.idScanning',
        category: SystemTranslationCategory.Common,
        defaultValue: 'ID Scanning',
        label: 'ID Scanning Dialog Heading',
    },
    {
        key: 'common.idVerificationMethodPrompt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select a method to verify your ID.',
        label: 'ID Verification Method Prompt',
    },
    {
        key: 'common.verifyUsingText',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verify using text',
        label: 'Verify Identity By Text Option',
    },
    {
        key: 'common.verifyUsingQrCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verify using a QR code',
        label: 'Verify Identity By QR Code Option',
    },
    {
        key: 'common.resendIn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Resend in {{minutes}}:{{seconds}}',
        label: 'Verification Text Resend Countdown',
        params: ['minutes', 'seconds'],
    },
    {
        key: 'common.policyAgreementRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You need to check that you agree to the terms of this policy to save.',
        label: 'Policy Agreement Required Tooltip',
    },
    {
        key: 'common.declineConditions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Decline Conditions',
        label: 'Decline Conditions Button',
    },
    {
        key: 'common.continueWithConditions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Continue With Conditions',
        label: 'Continue With Conditions Button',
    },
    {
        key: 'common.makePayment',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Make Payment',
        label: 'Make Payment Button',
    },
    {
        key: 'common.welcomeApplicant',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Welcome, {{name}}',
        label: 'Welcome Applicant Heading',
        params: ['name'],
    },
    {
        key: 'common.selectAlternateId',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please Select an Alternate ID:',
        label: 'Select Alternate ID Label',
    },
    {
        key: 'common.selectAlternateIds',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please Select {{count}} Alternate IDs:',
        label: 'Select Alternate IDs Label',
        params: ['count'],
    },
    {
        key: 'common.primaryId',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Primary ID',
        label: 'Primary ID Heading',
    },
    {
        key: 'common.additionalId',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Additional ID',
        label: 'Additional ID Heading',
    },
    {
        key: 'common.alternateId',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Alternate ID',
        label: 'Alternate ID Heading',
    },
    {
        key: 'common.optional',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Optional',
        label: 'Optional Field Label',
    },
    {
        key: 'common.postalCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Postal Code',
        label: 'Postal Code Label',
    },
    {
        key: 'common.contactPostalCode',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Contact Postal Code',
        label: 'Contact Postal Code Label',
    },
    {
        key: 'common.beginVerification',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Begin Verification',
        label: 'Begin Verification Button',
    },
    {
        key: 'common.incomeVerificationDurationNote',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please note, this process may take up to 30 minutes to complete.',
        label: 'Income Verification Duration Note',
    },
    {
        key: 'common.loadingVerificationStatus',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading Status',
        label: 'Loading Verification Status',
    },
    {
        key: 'common.verificationStatusUnavailable',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Verification status is currently unavailable. Please try again later.',
        label: 'Verification Status Unavailable Message',
    },
    {
        key: 'common.noPaymentTypeConfigured',
        category: SystemTranslationCategory.Common,
        defaultValue: 'No Payment Type Configure',
        label: 'No Payment Type Configured Message',
    },
    {
        key: 'common.moneygramInstruction',
        category: SystemTranslationCategory.Common,
        defaultValue: 'MoneyGram Instruction',
        label: 'MoneyGram Instruction Title',
    },
    {
        key: 'common.contactOfficeQuestions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please contact our office if you have any questions.',
        label: 'Contact Office Questions Message',
    },
    // Footer
    {
        key: 'footer.termsAndConditions',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Terms & Conditions',
        label: 'Terms & Conditions Link',
    },
    {
        key: 'footer.termsAndConditionsTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Terms and Conditions',
        label: 'Terms and Conditions Modal Title',
    },
    // Common
    {
        key: 'common.loading',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading...',
        label: 'Loading Text',
    },
    {
        key: 'common.loadingApplication',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Loading application',
        label: 'Loading Application Text',
    },
    {
        key: 'common.termsOfUse',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Terms of Use',
        label: 'Terms of Use Link',
    },
    {
        key: 'common.help',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Help',
        label: 'Help Link',
    },
    {
        key: 'common.privacy',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Privacy',
        label: 'Privacy Link',
    },
    // Viewer shell and recovery flows
    {
        key: 'common.submit',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Submit',
        label: 'Submit Button',
    },
    {
        key: 'common.selectLanguage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select language',
        label: 'Language Selector Accessibility Label',
    },
    {
        key: 'common.selectLanguageCurrent',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Select language, current language {{language}}',
        label: 'Current Language Selector Accessibility Label',
        params: ['language'],
    },
    {
        key: 'common.upload.closeFile',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Close button',
        label: 'Remove Uploaded File Accessibility Label',
    },
    {
        key: 'common.upload.dragAndDrop',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Drag and drop your files here',
        label: 'File Upload Dropzone Instructions',
    },
    {
        key: 'common.upload.browseFiles',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Browse files',
        label: 'File Upload Browse Action',
    },
    {
        key: 'common.upload.maximumFiles',
        category: SystemTranslationCategory.Common,
        defaultValue: '(maximum allowed is {{count}})',
        label: 'File Upload Maximum Files Hint',
        params: ['count'],
    },
    {
        key: 'common.upload.minimumFiles',
        category: SystemTranslationCategory.Common,
        defaultValue: '(min. required is {{count}})',
        label: 'File Upload Minimum Files Hint',
        params: ['count'],
    },
    {
        key: 'common.upload.acceptedFileTypes',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Accepted file types: {{types}}',
        label: 'File Upload Accepted Types Hint',
        params: ['types'],
    },
    {
        key: 'common.upload.fileRequired',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please select a file.',
        label: 'File Upload Required Error',
    },
    {
        key: 'common.upload.minimumFilesError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload min is {{count}} documents',
        label: 'File Upload Minimum Files Error',
        params: ['count'],
    },
    {
        key: 'common.upload.maximumFilesError',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload max is {{count}} documents',
        label: 'File Upload Maximum Files Error',
        params: ['count'],
    },
    {
        key: 'common.upload.invalidFileType',
        category: SystemTranslationCategory.Common,
        defaultValue: 'File type is not accepted.',
        label: 'File Upload Invalid Type Error',
    },
    {
        key: 'common.upload.fileTooLarge',
        category: SystemTranslationCategory.Common,
        defaultValue: 'File is too large.',
        label: 'File Upload Too Large Error',
    },
    {
        key: 'common.upload.fileTooSmall',
        category: SystemTranslationCategory.Common,
        defaultValue: 'File is too small.',
        label: 'File Upload Too Small Error',
    },
    {
        key: 'common.upload.tooManyFiles',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Too many files selected.',
        label: 'File Upload Too Many Files Error',
    },
    {
        key: 'common.upload.fileRejected',
        category: SystemTranslationCategory.Common,
        defaultValue: 'File could not be uploaded.',
        label: 'File Upload Generic Rejection Error',
    },
    {
        key: 'documents.uploadDocument',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Upload Document',
        label: 'Upload Document Modal Title',
    },
    {
        key: 'common.propertySelectionPrompt',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please specify to which property you would like to apply:',
        label: 'Target Property Selection Prompt',
    },
    {
        key: 'leadProfile.applicationStarted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Started {{date}} ({{relativeDate}})',
        label: 'Lead Profile Application Start Date',
        params: ['date', 'relativeDate'],
    },
    {
        key: 'leadProfile.activity',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Activity',
        label: 'Lead Profile Activity Button',
    },
    {
        key: 'leadProfile.openSettings',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Open settings',
        label: 'Lead Profile Settings Accessibility Label',
    },
    {
        key: 'leadProfile.today',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Today',
        label: 'Lead Profile Today Relative Date',
    },
    {
        key: 'leadProfile.dayAgo',
        category: SystemTranslationCategory.Common,
        defaultValue: '1 day ago',
        label: 'Lead Profile One Day Ago Relative Date',
    },
    {
        key: 'leadProfile.daysAgo',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{count}} days ago',
        label: 'Lead Profile Multiple Days Ago Relative Date',
        params: ['count'],
    },
    {
        key: 'waitlist.status.notOffered',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You are currently on the waitlist, an offer will be available soon.',
        label: 'Waitlist No Offer Status',
    },
    {
        key: 'waitlist.status.offered',
        category: SystemTranslationCategory.Common,
        defaultValue: 'An offer is available for you.',
        label: 'Waitlist Offer Available Status',
    },
    {
        key: 'waitlist.status.accepted',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You have accepted the waitlist offer.',
        label: 'Waitlist Offer Accepted Status',
    },
    {
        key: 'waitlist.status.declined',
        category: SystemTranslationCategory.Common,
        defaultValue: 'You have declined the waitlist offer. Another offer will be available soon.',
        label: 'Waitlist Offer Declined Status',
    },
    {
        key: 'waitlist.bedBath',
        category: SystemTranslationCategory.Common,
        defaultValue: '{{bedrooms}} bed/{{bathrooms}} bath',
        label: 'Waitlist Bedroom and Bathroom Count',
        params: ['bedrooms', 'bathrooms'],
    },
    {
        key: 'waitlist.offerNumber',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Offer #{{offerNumber}}',
        label: 'Waitlist Offer Number',
        params: ['offerNumber'],
    },
    {
        key: 'payment.error.authenticationTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Authentication Error',
        label: 'Payment Authentication Error Title',
    },
    {
        key: 'payment.error.validationTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Information Required',
        label: 'Payment Validation Error Title',
    },
    {
        key: 'payment.error.serviceUnavailableTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Service Unavailable',
        label: 'Payment Service Unavailable Error Title',
    },
    {
        key: 'payment.error.processingTitle',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Processing Error',
        label: 'Payment Processing Error Title',
    },
    {
        key: 'payment.error.title',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment Error',
        label: 'Payment Error Title',
    },
    {
        key: 'payment.error.authenticationMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment service authentication issue. Please try again or contact support.',
        label: 'Payment Authentication Error Message',
    },
    {
        key: 'payment.error.validationMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment information is incomplete or invalid. Please check your details.',
        label: 'Payment Validation Error Message',
    },
    {
        key: 'payment.error.serviceUnavailableMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Payment service temporarily unavailable. Please try again in a few moments.',
        label: 'Payment Service Unavailable Error Message',
    },
    {
        key: 'payment.error.processingMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Unable to process payment. Please verify your payment method or try a different one.',
        label: 'Payment Processing Error Message',
    },
    {
        key: 'payment.error.unexpectedMessage',
        category: SystemTranslationCategory.Common,
        defaultValue: 'An unexpected error occurred while processing payment. Please try again.',
        label: 'Unexpected Payment Error Message',
    },
    {
        key: 'payment.error.tryAgain',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Try Again',
        label: 'Payment Retry Button',
    },
    {
        key: 'payment.error.contactSupport',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Contact Support',
        label: 'Payment Contact Support Button',
    },
    {
        key: 'payment.error.checkDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Check Payment Details',
        label: 'Payment Details Button',
    },
    {
        key: 'payment.error.changeMethod',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Change Payment Method',
        label: 'Change Payment Method Button',
    },
    {
        key: 'payment.error.code',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error Code: {{code}}',
        label: 'Payment Error Code',
        params: ['code'],
    },
    {
        key: 'payment.error.retryingService',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Attempting to reconnect to payment service... (Attempt {{attempt}} of {{maxRetries}})',
        label: 'Payment Service Retry Status',
        params: ['attempt', 'maxRetries'],
    },
    {
        key: 'payment.error.reprocessing',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Reprocessing payment... (Attempt {{attempt}} of {{maxRetries}})',
        label: 'Payment Processing Retry Status',
        params: ['attempt', 'maxRetries'],
    },
    {
        key: 'payment.error.retrying',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Retrying payment... (Attempt {{attempt}} of {{maxRetries}})',
        label: 'Payment Retry Status',
        params: ['attempt', 'maxRetries'],
    },
    {
        key: 'payment.error.retryingIn',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Retrying in {{seconds}}s...',
        label: 'Payment Retry Countdown',
        params: ['seconds'],
    },
    {
        key: 'payment.error.serviceRetryDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: "Our payment service is experiencing temporary issues. We're automatically retrying your request.",
        label: 'Payment Service Retry Details',
    },
    {
        key: 'payment.error.processingRetryDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Processing your payment again. If this continues to fail, please try a different payment method.',
        label: 'Payment Processing Retry Details',
    },
    {
        key: 'payment.error.validationDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Please review your payment information and ensure all required fields are filled out correctly.',
        label: 'Payment Validation Details',
    },
    {
        key: 'payment.error.processingDetails',
        category: SystemTranslationCategory.Common,
        defaultValue: 'This could be due to insufficient funds, an expired card, or other payment method issues.',
        label: 'Payment Processing Details',
    },
    // Error Messages
    {
        key: 'error.loginFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error while logging in.',
        label: 'Login Error Message',
    },
    {
        key: 'error.createAccountFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error while creating an account',
        label: 'Create Account Error Message',
    },
    {
        key: 'error.createAccountDuplicate',
        category: SystemTranslationCategory.Common,
        defaultValue: "Error while creating an account. Please be sure you are using an email address and phone number that hasn't already been used.",
        label: 'Duplicate Account Error Message',
    },
    {
        key: 'error.passwordResetFailed',
        category: SystemTranslationCategory.Common,
        defaultValue: 'Error requesting password reset.',
        label: 'Password Reset Error Message',
    },
];
/**
 * Helper function to get system translatable items grouped by category
 */
function getSystemTranslatableItems() {
    var items = new SystemTranslatableItems();
    for (var _i = 0, DEFAULT_SYSTEM_TRANSLATIONS_1 = exports.DEFAULT_SYSTEM_TRANSLATIONS; _i < DEFAULT_SYSTEM_TRANSLATIONS_1.length; _i++) {
        var item = DEFAULT_SYSTEM_TRANSLATIONS_1[_i];
        // Exclude items that belong to the property-level UI — those are managed
        // per-property in the Property Language Overrides, not per-application.
        var isPropertyLevel = isPropertyLevelTranslationKey(item.key);
        if (isPropertyLevel)
            continue;
        var scopedItem = __assign(__assign({}, item), { scope: SystemTranslationScope.Application });
        switch (item.category) {
            case SystemTranslationCategory.Navigation:
                items.navigation.push(scopedItem);
                break;
            case SystemTranslationCategory.Login:
                items.login.push(scopedItem);
                break;
            case SystemTranslationCategory.Signup:
                items.signup.push(scopedItem);
                break;
            case SystemTranslationCategory.Validation:
                items.validation.push(scopedItem);
                break;
            case SystemTranslationCategory.Notifications:
                items.notifications.push(scopedItem);
                break;
            case SystemTranslationCategory.Common:
                items.common.push(scopedItem);
                break;
        }
    }
    return items;
}
/**
 * Property-level translatable items: only the phrases shown on pre-application screens
 * (login, signup, forgot-password, and the post-login entry/dashboard page).
 * These are the keys that make sense to configure per-property rather than per-application.
 */
exports.PROPERTY_TRANSLATABLE_KEY_PREFIXES = [
    'shell.login.',
    'shell.signup.',
    'shell.forgotPassword.',
    'entry.',
];
/**
 * Screening conditions flow keys: shown on Screening Conditions, Payment, and Confirmation
 * pages. Managed at property level so one set of translations applies to all applications
 * at the property (Option A: property-only).
 */
exports.PROPERTY_LEVEL_SCREENING_KEYS = new Set([
    'common.conditionallyApproved',
    'common.screeningApprovedDescription',
    'common.screeningSelectOption',
    'common.screeningChooseOptions',
    'common.screeningAllOptions',
    'common.screeningConditionAnd',
    'common.screeningConditionOr',
    'common.screeningConditionHeadingWithOperator',
    'common.screeningInvalidSelection',
    'common.screeningRequiredGuarantorFields',
    'common.screeningOptionsSaved',
    'common.screeningOptionsSavedGuarantor',
    'common.screeningOptionsSavedPayment',
    'common.screeningConditionSelected',
    'common.screeningConditionsSelected',
    'common.depositAlternativeConditionPricing',
    'common.decliningScreeningConditions',
    'common.applyingScreeningConditions',
    'common.addingGuarantor',
    'common.guarantorFirstName',
    'common.guarantorLastName',
    'common.guarantorDateOfBirth',
    'common.guarantorPhone',
    'common.guarantorEmail',
    'common.guarantorRelationship',
    'common.declineConditions',
    'common.continueWithConditions',
    'common.welcomeApplicant',
    'common.contactOfficeQuestions',
    'common.cancel',
    'common.makePayment',
    'common.gettingPaymentAccounts',
    'common.addingPayment',
    'common.processingPayment',
    'payment.chargesDue',
    'nav.backToHome',
]);
/**
 * Pre-application UI strings not covered by {@link PROPERTY_TRANSLATABLE_KEY_PREFIXES}
 * (e.g. auth card footer links). Shown in Property Language Overrides and returned by
 * property-scoped viewer translation APIs.
 */
exports.PROPERTY_LEVEL_PRE_APPLICATION_KEYS = new Set([
    'common.termsOfUse',
    'common.tryAgain',
    'waitlist.unitAvailable',
    'waitlist.unitsAvailable',
    'waitlist.availableSingleFloorPlanMessage',
    'waitlist.availableMultipleFloorPlansMessage',
    'waitlist.thisWaitlist',
    'waitlist.allWaitlists',
    'waitlist.bedroomsBathrooms',
    'waitlist.leavingWaitlist',
    'waitlist.leavingWaitlists',
    'waitlist.leaveWaitlist',
    'waitlist.leaveAllWaitlists',
    'waitlist.stayOnWaitlist',
    'waitlist.stayOnWaitlists',
]);
function isPropertyLevelTranslationKey(key) {
    return (exports.PROPERTY_TRANSLATABLE_KEY_PREFIXES.some(function (prefix) {
        return key.startsWith(prefix);
    }) ||
        exports.PROPERTY_LEVEL_SCREENING_KEYS.has(key) ||
        exports.PROPERTY_LEVEL_PRE_APPLICATION_KEYS.has(key));
}
/**
 * Returns a filtered subset of system translatable items that are relevant for
 * property-level translations (pre-application screens: login, signup, forgot
 * password, entry/dashboard, screening flow, and e.g. Terms of Use link on auth).
 */
function getPropertySystemTranslatableItems() {
    var items = new SystemTranslatableItems();
    for (var _i = 0, DEFAULT_SYSTEM_TRANSLATIONS_2 = exports.DEFAULT_SYSTEM_TRANSLATIONS; _i < DEFAULT_SYSTEM_TRANSLATIONS_2.length; _i++) {
        var item = DEFAULT_SYSTEM_TRANSLATIONS_2[_i];
        var isPropertyLevel = isPropertyLevelTranslationKey(item.key);
        if (!isPropertyLevel)
            continue;
        var scopedItem = __assign(__assign({}, item), { scope: SystemTranslationScope.Property });
        switch (item.category) {
            case SystemTranslationCategory.Login:
                items.login.push(scopedItem);
                break;
            case SystemTranslationCategory.Signup:
                items.signup.push(scopedItem);
                break;
            case SystemTranslationCategory.Navigation:
                items.navigation.push(scopedItem);
                break;
            case SystemTranslationCategory.Common:
                items.common.push(scopedItem);
                break;
            default:
                break;
        }
    }
    return items;
}
/**
 * Helper function to get a map of default translations (key -> defaultValue)
 */
function getDefaultSystemTranslationsMap() {
    var map = {};
    for (var _i = 0, DEFAULT_SYSTEM_TRANSLATIONS_3 = exports.DEFAULT_SYSTEM_TRANSLATIONS; _i < DEFAULT_SYSTEM_TRANSLATIONS_3.length; _i++) {
        var item = DEFAULT_SYSTEM_TRANSLATIONS_3[_i];
        map[item.key] = item.defaultValue;
    }
    return map;
}
/**
 * Flat map of system translation key → default English value.
 * Use this as the fallback in t() calls so default labels live in one place.
 */
exports.SYSTEM_TRANSLATION_DEFAULTS = Object.fromEntries(exports.DEFAULT_SYSTEM_TRANSLATIONS.map(function (item) { return [item.key, item.defaultValue]; }));
/**
 * Translation keys derived from DEFAULT_SYSTEM_TRANSLATIONS for programmatic use.
 * Use these in the form viewer UI instead of hardcoding key strings - single source of truth
 * with the definitions used by the translations API endpoints.
 *
 * Usage: SystemTranslationKeys.nav.next === 'nav.next'
 */
exports.SystemTranslationKeys = (function () {
    var result = {};
    for (var _i = 0, DEFAULT_SYSTEM_TRANSLATIONS_4 = exports.DEFAULT_SYSTEM_TRANSLATIONS; _i < DEFAULT_SYSTEM_TRANSLATIONS_4.length; _i++) {
        var item = DEFAULT_SYSTEM_TRANSLATIONS_4[_i];
        var parts = item.key.split('.');
        var current = result;
        for (var i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]])
                current[parts[i]] = {};
            current = current[parts[i]];
        }
        current[parts[parts.length - 1]] = item.key;
    }
    return result;
})();
/**
 * Navigation keys shown in Smart Routes language overrides and included in combined
 * CSV export / auto-translate for route-type applications.
 */
exports.ROUTE_COMBINED_UI_NAVIGATION_KEY_SET = new Set([
    exports.SystemTranslationKeys.nav.continue,
    exports.SystemTranslationKeys.nav.back,
    exports.SystemTranslationKeys.nav.next,
]);
/**
 * Regex patterns for validating system translation keys during CSV import and save.
 * Must be kept in sync with DEFAULT_SYSTEM_TRANSLATIONS - when adding new key prefixes,
 * add the pattern here.
 */
exports.SYSTEM_TRANSLATION_KEY_PATTERNS = [
    /^nav\.[\w-]+(\.[\w-]+)*$/,
    /^shell\.login\.[\w-]+$/,
    /^shell\.signup\.[\w-]+$/,
    /^shell\.forgotPassword\.[\w-]+$/,
    /^shell\.passwordless\.[\w-]+$/,
    /^validation\.[\w-]+$/,
    /^verification\.[\w-]+(\.[\w-]+)*$/,
    /^notification\.[\w-]+(\.[\w-]+)*$/,
    /^common\.[\w-]+(\.[\w-]+)*$/,
    /^error\.[\w-]+$/,
    /^floorPlan\.[\w-]+$/,
    /^payment\.[\w-]+(\.[\w-]+)*$/,
    /^documents\.[\w-]+$/,
    /^entry\.[\w-]+$/,
    /^thankYou\.[\w-]+$/,
    /^footer\.[\w-]+$/,
    /^summary\.[\w-]+$/,
    /^cart\.[\w-]+(\.[\w-]+)*$/,
    /^offers\.[\w-]+$/,
    /^appStatus\.[\w-]+$/,
    /^waitlist\.[\w-]+(\.[\w-]+)*$/,
    /^leadProfile\.[\w-]+$/,
];
